<template>
  <div>
    <div style="margin-top: 40px; display: flex; gap: 30px; align-items: center">
      <el-button size="mini" @click="m__back_to_list">
        <strong><i style="font-weight: bold" class="el-icon-arrow-left"></i> {{ $t('base.back') }}</strong>
      </el-button>
      <strong style="font-size: 18px"> {{ $t('base.create_new_campaign') }} </strong>
    </div>

    <div style="margin-top: 50px">
      <strong style="font-size: 15px">{{ $t('base.basic_settings') }}</strong>

      <div style="display: flex; margin-top: 30px;">
        <div style="width: 150px">
          <span style="font-size: 13px">{{ $t('base.ad_name') }}</span>
        </div>
        <div style="display: flex; gap: 10px; align-items: center">
          <el-input v-model="campaign_info.name" size="mini" :placeholder="$t('input.ad_name')" style="width: 300px">
          </el-input>
        </div>
      </div>

      <div v-if="config_campaign_price_type === 'manual'" style="display: flex; margin-top: 30px;">
        <div style="width: 150px">
          <span style="font-size: 13px">{{ $t('base.tagline') }}</span>
        </div>
      </div>

      <div style="display: flex; margin-top: 30px;">
        <div style="width: 150px">
          <span style="font-size: 13px">{{ $t('base.budget') }}</span>
        </div>
        <div style="display: flex; gap: 10px; align-items: center">
          <el-radio v-model="campaign_info.budget_type" label="unlimited">{{ $t('base.unlimited') }}</el-radio>
          <el-radio v-model="campaign_info.budget_type" label="daily_budget">{{ $t('base.daily_budget') }}</el-radio>
          <el-input v-if="campaign_info.budget_type === 'daily_budget'" v-model="campaign_info.daily_budget"
                    type="number" size="mini"></el-input>
        </div>
      </div>

      <div style="display: flex; margin-top: 30px;">
        <div style="width: 150px">
          <span style="font-size: 13px">{{ $t('base.duration') }}</span>
        </div>
        <div style="display: flex; gap: 10px; align-items: center">
          <el-radio v-model="campaign_info.campaign_time" label="unlimited">{{ $t('base.unlimited') }}</el-radio>
          <el-radio v-model="campaign_info.campaign_time" label="daterange">{{
              $t('base.set_start_end_date')
            }}
          </el-radio>
          <el-date-picker
            v-if="campaign_info.campaign_time === 'daterange'"
            v-model="campaign_info.campaign_date_range"
            type="daterange" range-separator="-"
            :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')" size="mini"
            format="dd-MM-yyyy">
          </el-date-picker>
        </div>
      </div>
    </div>

    <div style="margin-top: 50px">
      <strong style="font-size: 15px">{{ $t('base.bidding') }}</strong>

      <div style="margin-top: 30px; display: flex; gap: 20px">
        <div
          style="flex: 1; border: 1px solid #e5e5e5; border-radius: 8px; padding: 20px; display: flex; gap: 10px; cursor: pointer; position: relative"
          :style="config_campaign_price_type === 'auto' ? 'border: 1px solid #ee4d2d' : ''"
          @click="(c__auto_is_eligible) && (config_campaign_price_type = 'auto')">
          <div style="flex: 1; display: flex; flex-direction: column; gap: 10px;">
            <div style="font-size: 14px">{{ 'Giá thầu Tự động' }}</div>
            <div style="color: #999; font-size: 13px">
              <template v-if="c__auto_is_eligible">
                {{
                  'Shopee sẽ tối ưu hóa việc hiển thị quảng cáo của bạn cho người mua sắm, giúp bạn đạt hiệu quả cao nhất. '
                }}
              </template>
              <template v-else>
                {{
                  'Bạn đã có 01 Quảng cáo Shop ở chế độ Giá thầu Tự động.'
                }}
                <a
                  v-if="c__auto_ongoing_campaign_id"
                  :href="`/marketing/pas?type=shop_homepage&shop_id=${shop.shop_id}&campaign_id=${c__auto_ongoing_campaign_id}`"
                  target="_blank" style="position: absolute; z-index: 10; margin-left: 5px; font-size: 13px">
                  Xem chiến dịch
                </a>
              </template>
            </div>
          </div>
          <div style="width: 60px; height: 60px">
            <img
              src="https://deo.shopeemobile.com/shopee/shopee-seller-live-sg/mmf_portal_seller_root_dir/static/modules/pas-shop/image/bidding_auto.4b5180b.jpg"
              alt="" style="width: 100%; height: 100%; object-fit: contain"
              :class="c__auto_is_not_eligible ? 'disabled-mask-img' : ''">
          </div>

          <div :class="c__auto_is_not_eligible ? 'disabled-mask' : 'display-none'"></div>
        </div>
        <div
          style="flex: 1; border: 1px solid #e5e5e5; border-radius: 8px; padding: 20px; display: flex; gap: 10px; cursor: pointer;"
          :style="config_campaign_price_type === 'manual' ? 'border: 1px solid #ee4d2d' : ''"
          @click="config_campaign_price_type = 'manual'">
          <div style="flex: 1; display: flex; flex-direction: column; gap: 10px;">
            <div style="font-size: 14px">{{ $t('base.manual_bidding') }}</div>
            <div style="color: #999; font-size: 13px">
              {{ $t('base.optional_bidding') }}
            </div>
          </div>
          <div style="width: 60px; height: 60px">
            <img
              src="https://deo.shopeemobile.com/shopee/shopee-seller-live-sg/mmf_portal_seller_root_dir/static/modules/pas-shop/image/bidding_manual.2668ccb.jpg"
              alt="" style="width: 100%; height: 100%; object-fit: contain">
          </div>
        </div>
      </div>
    </div>

    <template v-if="false && config_campaign_price_type === 'auto'">
      <div style="margin-top: 50px">
        <strong class="text-danger" style="font-size: 15px">*</strong>
        <strong style="font-size: 15px">
          {{ $t('base.target_roas') }}
        </strong>

        <div style="margin-top: 30px">
          <div>
            <el-radio v-model="form_update_target_broad_roi.type" :label="'auto'">
              {{ $t('create_ads.auto_bidding') }}
            </el-radio>
            <div>
              {{ $t('create_ads.auto_bidding_message') }}
            </div>
          </div>
          <div style="margin-top: 20px">
            <el-radio v-model="form_update_target_broad_roi.type" :label="'custom'">
              {{ $t('create_ads.manual_bidding') }}
            </el-radio>
            <div>
              {{ $t('base.set_your_own_roas') }}
            </div>
          </div>
          <div v-if="form_update_target_broad_roi.type === 'custom'"
               style="margin-top: 20px; padding-left: 10px; display: flex; flex-direction: column; gap: 10px">
            <div v-for="item in form_update_target_broad_roi.custom_type_list" :key="item" style="display: flex">
              <div style="width: 150px">
                <el-radio v-model="form_update_target_broad_roi.custom_type" :label="item">
                  ROAS = {{ item / 100000 }}
                </el-radio>
              </div>
              <div>

              </div>
            </div>
            <div style="display: flex">
              <div style="width: 150px">
                <el-radio v-model="form_update_target_broad_roi.custom_type" :label="'custom'">
                  {{ $t('create_ads.custom') }}
                </el-radio>
              </div>
              <div style="flex: 1; padding-right: 10px">
                <el-input type="number" v-model="form_update_target_broad_roi.custom_value" :min="1" :max="50"
                          size="mini" placeholder="1.0 ~ 50.0" style="width: 300px">
                </el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="['all', 'search'].includes(campaign_info.campaign_type) && config_campaign_price_type === 'manual'">
      <div style="margin-top: 50px">
        <strong class="text-danger" style="font-size: 15px">*</strong>
        <strong style="font-size: 15px">
          {{ $t('ads.add_keywords') }}
        </strong>

        <div>
          <el-row style="margin-top: 10px">
            <el-col :sm="15" style="padding-right: 20px">
              <p class="text-title">{{ $t('base.keyword_selection') }}</p>
              <br>
              <div style="height: 50px; margin: 15px 0 0 0;">
                <div class="atosa-tab">
                  <div class="atosa-tab-item" :class="radio === '1' ? 'atosa-tab-item-active': ''" @click="radio = '1'">
                    {{ $t('base.shopee_recommend') }}
                  </div>
                  <div v-if="m__check_marketing_package('keyword_tool')"
                       class="atosa-tab-item" :class="radio === '4' ? 'atosa-tab-item-active': ''" @click="radio = '4'">
                    {{ $t('menu.atosa_keyword_tool') }}
                  </div>
                  <div class="atosa-tab-item" :class="radio === '2' ? 'atosa-tab-item-active': ''" @click="radio = '2'">
                    {{ $t('keyword.file') }} (Atosa)
                  </div>
                  <div class="atosa-tab-item" :class="radio === '3' ? 'atosa-tab-item-active': ''" @click="radio = '3'">
                    {{ $t('base.search_keywords') }}
                  </div>
                  <div class="atosa-tab-item" :class="radio === '5' ? 'atosa-tab-item-active': ''" @click="radio = '5'">
                    Import Excel
                  </div>
                  <br>
                </div>
              </div>

              <template v-if="radio === '1'">
                <div style="height: 24px; margin-top: 10px">
                </div>
                <el-table :data="c__shopee_keyword_display_list"
                          @sort-change="({prop, order}) => {shopee_filter.sort_option.order = order; shopee_filter.sort_option.prop = prop}">
                  <el-table-column
                    :label="$t('base.keyword')"
                    prop="keyword">
                  </el-table-column>
                  <el-table-column
                    :label="$t('base.volume')"
                    prop="search_volume"
                    sortable="custom">
                    <template slot-scope="scope">{{ scope.row.search_volume | currency }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('base.relevance')" prop="relevance" sortable="custom">
                    <template slot-scope="scope">{{ scope.row.relevance | currency }}/10</template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('base.recommend_price')" prop="recommend_price" sortable="custom">
                    <template slot-scope="scope">
                      <el-input size="mini" v-model="scope.row.recommend_price" type="number"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('base.action')"
                    align="right"
                    width="90px">
                    <template slot-scope="scope">
                      <div style="padding-top: 5px">
                        <strong v-if="m__can_add(scope.row)" href="javascript:void(0)" type="text" class="text-info"
                                @click="m__add_keyword(scope.row, 'shopee_suggest_keywords')">
                          <strong>{{ $t('base.add') }} ></strong></strong>
                        <strong v-else href="javascript:void(0)" class="text-grey">{{ $t('base.added') }}</strong>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination :current-page.sync="shopee_filter.current_page" :page-size="shopee_filter.page_size"
                               layout="prev, pager, next, total" :total="shopee_suggest_keywords.length"/>
              </template>

              <template v-if="radio === '2'">
                <div style="height: 35px;">
                  <el-row>
                    <el-col :sm="12">
                      <el-select size="mini" value="" v-model="selected_keyword_file"
                                 @change="m__get_keyword_file_detail"
                                 filterable :placeholder="$t('select.keyword_file')" style="width: 250px">
                        <el-option v-for="keyword in keyword_file_list" :key="keyword._id" :value="keyword._id"
                                   :label="keyword.filename"></el-option>
                      </el-select>
                      &nbsp;&nbsp;
                      <strong><a href="javascript:void(0)" style="color: orangered"
                                 @click="m__get_keyword_file">({{ $t('base.update') }})</a></strong>
                    </el-col>
                    <el-col :sm="12" class="text-right">
                      <el-select v-model="form_add_new_campaign.price_type" size="mini"
                                 style="border: none !important; width: 230px">
                        <el-option :value="'mipee'" :label="$t('base.use_saved_bid_price')"></el-option>
                        <el-option :value="'shopee'" :label="$t('base.use_shopee_bid_price')"></el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                </div>
                <el-table :data="c__mipee_keywords_display_list"
                          @sort-change="({prop, order}) => {mipee_filter.sort_option.order = order; mipee_filter.sort_option.prop = prop}">
                  <el-table-column :label="$t('base.keyword')" prop="keyword">
                    <template slot-scope="scope">{{ scope.row.keyword.normalize() }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('base.volume')" prop="search_volume" sortable="custom">
                    <template slot-scope="scope">{{ scope.row.search_volume | currency }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('base.saved_bid_price')" prop="price" sortable="custom">
                    <template slot-scope="scope" slot="header">
                      {{ $t('base.saved_bid_price') }} <span v-if="form_add_new_campaign.price_type === 'mipee'"
                                                             style="color: red">*</span>
                    </template>
                    <template slot-scope="scope">
                      <el-input size="mini" type="number" :min="400" v-model="scope.row.price"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('base.shopee_bid_price')" prop="recommend_price" sortable="custom">
                    <template slot-scope="scope" slot="header">
                      {{ $t('base.shopee_bid_price') }} <span v-if="form_add_new_campaign.price_type === 'shopee'"
                                                              style="color: red">*</span>
                    </template>
                    <template slot-scope="scope">
                      <el-input size="mini" type="number" :min="400" v-model="scope.row.recommend_price"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('base.action')" width="90px" align="right">
                    <template slot-scope="scope">
                      <strong v-if="m__can_add(scope.row)" href="javascript:void(0)" @click="m__add_keyword(scope.row)"
                              class="text-info">{{ $t('base.add') }} ></strong>
                      <strong v-else href="javascript:void(0)">{{ $t('base.added') }}</strong>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination :current-page.sync="mipee_filter.current_page" :page-size="mipee_filter.page_size"
                               layout="prev, pager, next, total" :total="mipee_suggest_keywords.length"/>
                <br>
              </template>

              <template v-if="radio === '3'">
                <div style="height: 35px;">
                  <el-autocomplete size="mini" :placeholder="$t('input.placeholder')" v-model="keyword"
                                   style="width: 250px" :fetch-suggestions="m__suggest_keyword"
                                   @select="m__search_sp_keyword"></el-autocomplete>
                </div>
                <el-table :data="c__search_keyword_display_list"
                          @sort-change="({prop, order}) => {search_keyword_filter.sort_option.order = order; search_keyword_filter.sort_option.prop = prop}">
                  <el-table-column :label="$t('base.keyword')" prop="keyword">
                    <template slot-scope="scope">{{ scope.row.keyword.normalize() }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('base.volume')" prop="sp_volume" sortable="custom">
                    <template slot-scope="scope">{{ scope.row.sp_volume | currency }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('base.relevance')" prop="relevance" sortable="custom">
                    <template slot-scope="scope">{{ scope.row.relevance | currency }}/10</template>
                  </el-table-column>
                  <el-table-column :label="$t('base.recommend_price')" prop="sp_price" sortable="custom">
                    <template slot-scope="scope">{{ scope.row.sp_price | currency }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('base.action')" width="90px" align="right">
                    <template slot-scope="scope">
                      <strong v-if="m__can_add(scope.row)" href="javascript:void(0)" @click="m__add_keyword(scope.row)"
                              class="text-info">{{ $t('base.add') }} ></strong>
                      <strong v-else href="javascript:void(0)">{{ $t('base.added') }}</strong>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination :current-page.sync="search_keyword_filter.current_page"
                               :page-size="search_keyword_filter.page_size"
                               layout="prev, pager, next, total" :total="search_keyword.length"/>
              </template>

              <template v-if="radio === '4'">
                <div style="height: 35px; margin-top: 9px">
                  <el-input size="mini" :placeholder="$t('input.placeholder')"
                            v-model="base_keyword" style="width: 250px" @keyup.enter.native="m__enter_input"></el-input>
                  <el-button size="mini" type="primary" icon="el-icon-search" :loading="fff_loading"
                             @click="m__try_get_keyword_result"> {{ $t('base.search') }}
                  </el-button>
                </div>
                <el-table :data="c__fff_result_display_list" @sort-change="m__fff_sort_change" class="fff-table">
                  <el-table-column :label="$t('base.keyword')" show-tooltip-when-overflow>
                    <template slot-scope="scope">
                      {{ scope.row.keyword.normalize() }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="sp_volume"
                    :label="$t('base.volume')" sortable="custom">
                    <template slot-scope="scope">
                      {{ scope.row.sp_volume | currency }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="sp_price"
                    :label="$t('base.recommend_price')" sortable="custom">
                    <template slot-scope="scope">
                      {{ scope.row.sp_price | currency }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('base.action')"
                    align="right" width="90px">
                    <template slot-scope="scope">
                      <div style="padding-top: 5px">
                        <strong v-if="m__can_add(scope.row)" href="javascript:void(0)" type="text" class="text-info"
                                @click="m__add_keyword(scope.row, 'shopee_suggest_keywords')">
                          <strong>{{ $t('base.add') }} ></strong></strong>
                        <strong v-else href="javascript:void(0)" class="text-grey">{{ $t('base.added') }}</strong>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination :current-page.sync="atosa_keyword_filter.current_page"
                               :page-size="atosa_keyword_filter.page_size"
                               layout="prev, pager, next, total" :total="fff_result.length"/>
              </template>

              <el-row v-if="radio === '5'">
                <div style="height: 35px;">
                  <el-button size="mini" type="primary" icon="ti-harddrives" @click="m__show_import_excel_file">
                    &nbsp;&nbsp;&nbsp;{{ $t('base.import_excel_file') }}
                  </el-button>
                  &nbsp;&nbsp;&nbsp;<strong class="text-danger">*{{ $t('keyword.import_note') }}</strong>
                </div>
                <el-table
                  :data="c__excel_keyword_display_list">
                  <el-table-column
                    :label="$t('base.keyword')">
                    <template slot-scope="scope">
                      {{ scope.row.keyword.normalize() }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="search_volume"
                    :label="$t('base.volume')" sortable>
                    <template slot-scope="scope">
                      {{ scope.row.search_volume | currency }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="recommend_price"
                    :label="$t('base.recommend_price')" sortable>
                    <template slot-scope="scope">
                      {{ scope.row.recommend_price | currency }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('base.action')" width="90px"
                    align="right">
                    <template slot-scope="scope">
                      <div style="padding-top: 5px">
                        <a v-if="m__can_add(scope.row)" href="javascript:void(0)" type="text"
                           @click="m__add_keyword(scope.row, 'shopee_suggest_keywords')">
                          <strong>{{ $t('base.add') }} ></strong></a>
                        <a v-else href="javascript:void(0)" class="text-grey">{{ $t('base.added') }}</a>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination :current-page.sync="excel_keyword_filter.current_page"
                               :page-size="excel_keyword_filter.page_size"
                               layout="prev, pager, next, total" :total="excel_keyword.length"/>
              </el-row>

              <br>
              <el-button size="mini" type="primary" @click="m__add_all">
                {{ radio !== '4' ? $t('keyword.add_all') : $t('keyword.add_top_x', {x: '100'}) }}
              </el-button>
              &nbsp;
              &nbsp;
              &nbsp;
              <el-checkbox v-model="omit_duplicated_keyword">{{ $t('base.remove_duplicated_keywords') }}</el-checkbox>
            </el-col>

            <el-col :sm="9" style="padding-left: 20px">
              <p class="text-title"> {{ $t('keyword.added_keywords') }}</p>
              <br>

              <div style="height: 50px; margin: 15px 0 10px 0;">
                <el-row>
                  <el-col :sm="24">
                    <el-select v-model="form_add_new_campaign.match_type" size="mini" style="border: none !important;">
                      <el-option :value="0" :label="$t('keyword.exact')"></el-option>
                      <el-option :value="1" :label="$t('keyword.broad')"></el-option>
                    </el-select>
                    &nbsp;
                    <el-button size="mini" @click="m__show_update_keyword_dialog"> {{
                        $t('base.edit_bid_price')
                      }}
                    </el-button>
                    <el-button size="mini" type="info" @click="added_keyword = []">Clear</el-button>
                  </el-col>
                </el-row>
              </div>

              <div style="height: 35px; margin-top: 10px">
              </div>

              <el-table :data="c__added_keyword_display_list">
                <el-table-column
                  :label="$t('base.keyword')"
                  prop="keyword"
                  show-tooltip-when-overflow>
                </el-table-column>
                <el-table-column width="120px" :label="$t('base.bid_price')">
                  <template slot-scope="scope">
                    <el-input size="mini" v-model="scope.row.recommend_price" type="number"></el-input>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('base.action')" align="right" width="90px">
                  <template slot-scope="scope">
                    <div style="padding-top: 5px">
                      <a href="javascript:void(0)" type="text" class="text-danger"
                         @click="m__remove_keyword(scope.row)">
                        <strong> {{ $t('base.delete') }}</strong></a>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination :current-page.sync="added_keyword_filter.current_page"
                             :page-size="added_keyword_filter.page_size"
                             layout="prev, pager, next, total" :total="added_keyword.length"/>

              <div class="text-right" style="margin-top: 10px">
                <el-button size="mini" type="primary" icon="ti-save"
                           @click="m__initial_save_keyword_file">{{ $t('keyword.save_file') }}
                </el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </template>

    <div style="margin-top: 50px">
      <strong style="font-size: 15px">{{ 'Nội dung quảng cáo' }}</strong>

      <div style="margin-top: 30px; display: flex; gap: 20px">
        <div
          style="flex: 1; border: 1px solid #e5e5e5; border-radius: 8px; padding: 20px; display: flex; gap: 10px; cursor: pointer; position: relative"
          :style="config_campaign_creative === 'default' ? 'border: 1px solid #ee4d2d' : ''"
          @click="config_campaign_creative = 'default'">
          <div style="flex: 1; display: flex; flex-direction: column; gap: 10px;">
            <div style="font-size: 14px">{{ 'Mặc định' }}</div>
            <div style="color: #999; font-size: 13px">
              {{
                'Tận dụng các thành phần nội dung mà Shop bạn đang có, bao gồm logo và tên Shop.'
              }}
              <a href="javascript:void(0)" style="position: absolute; z-index: 10; margin-left: 5px; font-size: 13px"
                 @click="show_dialog.preview_ads = true">
                Xem
              </a>
            </div>
          </div>
          <div style="width: 60px; height: 60px">
            <img
              src="https://deo.shopeemobile.com/shopee/shopee-seller-live-sg/mmf_portal_seller_root_dir/static/modules/pas-shop/image/default_creative.cfc8a3d.jpg"
              alt="" style="width: 100%; height: 100%; object-fit: contain">
          </div>
        </div>
        <div
          style="flex: 1; border: 1px solid #e5e5e5; border-radius: 8px; padding: 20px; display: flex; gap: 10px; cursor: pointer; position: relative"
          :style="config_campaign_creative === 'manual' ? 'border: 1px solid #ee4d2d' : ''"
          @click="(config_campaign_price_type === 'manual') && (config_campaign_creative = 'manual')">
          <div style="flex: 1; display: flex; flex-direction: column; gap: 10px;">
            <div style="font-size: 14px">{{ 'Tùy chỉnh' }}</div>
            <div style="color: #999; font-size: 13px">
              {{
                'Kiểm soát cách hiển thị quảng cáo của bạn thông qua tùy chỉnh hình ảnh và khẩu hiệu.'
              }}
            </div>

            <div :class="config_campaign_price_type === 'auto' ? 'disabled-mask' : 'display-none'"></div>
          </div>
          <div style="width: 60px; height: 60px">
            <img
              src="https://deo.shopeemobile.com/shopee/shopee-seller-live-sg/mmf_portal_seller_root_dir/static/modules/pas-shop/image/customize_creative.2a1dce1.jpg"
              alt="" style="width: 100%; height: 100%; object-fit: contain"
              :class="config_campaign_price_type === 'auto' ? 'disabled-mask-img' : ''">
          </div>
        </div>
      </div>

      <div v-if="config_campaign_creative === 'manual'" style="margin-top: 30px">
        <div
          style="width: 100%; height: auto; background-color: #fffbfa; padding: 20px 0; border-radius: 4px; display: flex; align-items: stretch">
          <div style="flex: 1; height: 100%; padding: 10px 40px; display: flex; flex-direction: column; gap: 20px">
            <div style="display: flex; gap: 20px">
              <div style="width: 106px; text-align: right">
                <small class="text-danger">*</small>
                <strong style="font-size: 13px">Hình ảnh</strong>
              </div>
              <div style="width: 90px; height: 90px; position: relative; border-radius: 50px; cursor: pointer"
                   class="group" @click="m__show_upload_shop_ads_image()">
                <img
                  :src="`https://cf.shopee.vn/file/${campaign_info.image_url}`"
                  alt="" style="width: 90px; height: 90px; object-fit: contain; border-radius: 50px">

                <div
                  style="position: absolute; top: 0; left: 0; width: 90px; height: 90px; background-color: rgba(0, 0, 0, 0.5); border-radius: 50px;"
                  class="hidden group-hover:!block">
                  <div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center">
                    <i class="el-icon-upload" style="color: #fff; font-size: 30px"></i>
                  </div>
                </div>
              </div>
            </div>

            <div style="display: flex; gap: 20px">
              <div style="width: 106px; text-align: right">
                <small class="text-danger">*</small>
                <strong style="font-size: 13px">Khẩu hiệu</strong>
              </div>
              <div style="display: flex; flex-direction: column; gap: 10px">
                <el-input v-model="campaign_info.tagline" size="mini" :placeholder="$t('input.tagline')"
                          style="width: 300px">
                </el-input>
                <span style="color: #999; font-size: 13px">
                  Thu hút người mua bằng cách nêu bật những điểm hấp dẫn của Shop bạn.
                </span>
              </div>
            </div>

            <div style="display: flex; gap: 20px">
              <div style="width: 106px; text-align: right">
                <strong style="font-size: 13px">Trang đích</strong>
              </div>
              <div>
                <span style="font-size: 13px">Tab sản phẩm của Shop</span>
              </div>
            </div>

            <div style="display: flex; gap: 20px">
              <div style="width: 106px; text-align: right">
                <strong style="font-size: 13px">Vị trí quảng cáo</strong>
              </div>
              <div style="display: flex; gap: 20px; align-items: center">
                <span style="font-size: 13px">Đầu Trang Kết quả Tìm kiếm</span>
                <a href="javascript:void(0)" @click="show_dialog.preview_ads = true" style="font-size: 13px">Xem ></a>
              </div>
            </div>
          </div>
          <div style="flex: 1; height: 100%; padding: 10px 40px; border-left: 1px solid #e5e5e5;">
            <div style="width: 460px; margin: 0 auto">
              <div style="display: flex; justify-content: space-between">
                <div>
                  <strong style="font-size: 14px;">Xem trước</strong>
                </div>
                <div>
                  <el-radio-group size="mini" v-model="has_voucher">
                    <el-radio-button label="true">Có voucher</el-radio-button>
                    <el-radio-button label="false">Không voucher</el-radio-button>
                  </el-radio-group>
                </div>
              </div>

              <div style="display: flex; flex-direction: column; gap: 20px; margin-top: 20px">
                <div>
                  <div>
                    <span style="color: #666">Ứng dụng Shopee</span>
                  </div>
                  <div style="margin-top: 5px">
                    <div style="border: 1px solid #eee; border-radius: 4px">
                      <div style="background-color: #fef4f3; padding: 10px; display: flex; gap: 10px">
                        <div style="width: 50px;">
                          <img :src="`https://cf.shopee.vn/file/${campaign_info.image_url}`" alt=""
                               style="width: 40px; height: 40px; object-fit: contain; border-radius: 50px">
                        </div>
                        <div style="flex: 1; display: flex; flex-direction: column; justify-content: space-between">
                          <div style="font-weight: 700; font-size: 13px">{{ shop.username.toUpperCase() }}</div>
                          <div style="display: flex; align-items: center; gap: 10px">
                            <img
                              src="https://deo.shopeemobile.com/shopee/shopee-seller-live-sg/mmf_portal_seller_root_dir/static/modules/pas-shop/image/label_preferred_vn.d0af0b3.jpg"
                              alt="">

                            <div style="display: flex; align-items: center; gap: 5px">
                              <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
                                   style="width: 13px; height: 13px; fill: #eda500">
                                <path
                                  d="M8 12.854L4.213 14.94a.487.487 0 01-.672-.219.543.543 0 01-.05-.33l.723-4.418-3.064-3.13a.539.539 0 01-.009-.736.49.49 0 01.285-.152L5.66 5.31l1.894-4.02a.487.487 0 01.892 0l1.894 4.02 4.234.645c.272.041.46.306.42.59a.53.53 0 01-.144.299l-3.064 3.129.723 4.417a.52.52 0 01-.406.602.478.478 0 01-.316-.052L8 12.854z"></path>
                              </svg>
                              <span style="color: #eda500; font-size: 12px">
                                {{
                                  shop_preview_data && shop_preview_data.shop_rating ? shop_preview_data.shop_rating.toFixed(1) : 0
                                }}
                              </span>
                            </div>

                            <span style="font-size: 12px">
                              {{
                                shop_preview_data && shop_preview_data.rating_count ? shop_preview_data.rating_count : 0 | currency
                              }}
                              Đánh Giá
                            </span>

                            <div
                              style="border: 1px solid rgba(0,0,0,.09); color: rgba(0,0,0,.26); font-size: 10px; padding: 2px 4px; border-radius: 2px; margin-left: 8px">
                              Ad
                            </div>
                          </div>
                        </div>
                        <div style="width: 100px; text-align: right">
                          <button
                            style="font-size: 11px; background-color: orangered; color: #fff; padding: 3px 10px; font-weight: bold">
                            Ghé shop
                          </button>
                        </div>
                      </div>
                      <div
                        style="padding: 10px; display: flex; gap: 5px; background-color: #fff; flex-wrap: nowrap; overflow: hidden">
                        <div v-if="has_voucher === 'true'">
                          <svg viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg"
                               style="width: 98px; height: 98px">
                            <mask id="path-2-inside-1_1809_21315" fill="white">
                              <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M0 4C0 1.79086 1.79086 0 4 0H94C96.2091 0 98 1.79086 98 4V57C95.7909 57 94 58.7909 94 61C94 63.2091 95.7909 65 98 65V94C98 96.2091 96.2091 98 94 98H4C1.79086 98 0 96.2091 0 94V65C2.20914 65 4 63.2091 4 61C4 58.7909 2.20914 57 0 57V4Z"></path>
                            </mask>
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M0 4C0 1.79086 1.79086 0 4 0H94C96.2091 0 98 1.79086 98 4V57C95.7909 57 94 58.7909 94 61C94 63.2091 95.7909 65 98 65V94C98 96.2091 96.2091 98 94 98H4C1.79086 98 0 96.2091 0 94V65C2.20914 65 4 63.2091 4 61C4 58.7909 2.20914 57 0 57V4Z"
                                  fill="#FFF4F4"></path>
                            <path
                              d="M98 57V57.5H98.5V57H98ZM98 65H98.5V64.5H98V65ZM0 65V64.5H-0.5V65H0ZM0 57H-0.5V57.5H0V57ZM4 -0.5C1.51472 -0.5 -0.5 1.51472 -0.5 4H0.5C0.5 2.067 2.067 0.5 4 0.5V-0.5ZM94 -0.5H4V0.5H94V-0.5ZM98.5 4C98.5 1.51472 96.4853 -0.5 94 -0.5V0.5C95.933 0.5 97.5 2.067 97.5 4H98.5ZM98.5 57V4H97.5V57H98.5ZM94.5 61C94.5 59.067 96.067 57.5 98 57.5V56.5C95.5147 56.5 93.5 58.5147 93.5 61H94.5ZM98 64.5C96.067 64.5 94.5 62.933 94.5 61H93.5C93.5 63.4853 95.5147 65.5 98 65.5V64.5ZM98.5 94V65H97.5V94H98.5ZM94 98.5C96.4853 98.5 98.5 96.4853 98.5 94H97.5C97.5 95.933 95.933 97.5 94 97.5V98.5ZM4 98.5H94V97.5H4V98.5ZM-0.5 94C-0.5 96.4853 1.51472 98.5 4 98.5V97.5C2.067 97.5 0.5 95.933 0.5 94H-0.5ZM-0.5 65V94H0.5V65H-0.5ZM3.5 61C3.5 62.933 1.933 64.5 0 64.5V65.5C2.48528 65.5 4.5 63.4853 4.5 61H3.5ZM0 57.5C1.933 57.5 3.5 59.067 3.5 61H4.5C4.5 58.5147 2.48528 56.5 0 56.5V57.5ZM-0.5 4V57H0.5V4H-0.5Z"
                              fill="#EE4D2D" fill-opacity="0.15" mask="url(#path-2-inside-1_1809_21315)"></path>
                            <line x1="8" y1="60.75" x2="90" y2="60.75" stroke="#EE4D2D" stroke-opacity="0.15"
                                  stroke-width="0.5" stroke-dasharray="2 2"></line>
                            <path
                              d="M40.1172 18.1875V22.5312C39.9557 22.7448 39.7031 22.9792 39.3594 23.2344C39.0208 23.4844 38.5703 23.7005 38.0078 23.8828C37.4453 24.0651 36.7448 24.1562 35.9062 24.1562C35.1927 24.1562 34.5391 24.0365 33.9453 23.7969C33.3516 23.5521 32.8385 23.1953 32.4062 22.7266C31.9792 22.2578 31.6484 21.6875 31.4141 21.0156C31.1797 20.3385 31.0625 19.5677 31.0625 18.7031V17.9141C31.0625 17.0547 31.1693 16.2891 31.3828 15.6172C31.6016 14.9401 31.9141 14.3672 32.3203 13.8984C32.7266 13.4297 33.2161 13.0755 33.7891 12.8359C34.3672 12.5911 35.0208 12.4688 35.75 12.4688C36.6823 12.4688 37.4531 12.625 38.0625 12.9375C38.6771 13.2448 39.151 13.6719 39.4844 14.2188C39.8177 14.7656 40.0286 15.3906 40.1172 16.0938H38.1953C38.1328 15.6979 38.0104 15.3438 37.8281 15.0312C37.651 14.7188 37.3958 14.474 37.0625 14.2969C36.7344 14.1146 36.3073 14.0234 35.7812 14.0234C35.3281 14.0234 34.9297 14.1094 34.5859 14.2812C34.2422 14.4531 33.9557 14.7057 33.7266 15.0391C33.5026 15.3724 33.3333 15.7786 33.2188 16.2578C33.1042 16.737 33.0469 17.2839 33.0469 17.8984V18.7031C33.0469 19.3281 33.112 19.8828 33.2422 20.3672C33.3776 20.8516 33.5703 21.2604 33.8203 21.5938C34.0755 21.9271 34.3854 22.1797 34.75 22.3516C35.1146 22.5182 35.526 22.6016 35.9844 22.6016C36.4323 22.6016 36.7995 22.5651 37.0859 22.4922C37.3724 22.4141 37.599 22.3229 37.7656 22.2188C37.9375 22.1094 38.0703 22.0052 38.1641 21.9062V19.6484H35.7969V18.1875H40.1172ZM44.1172 15.5469V24H42.2266V15.5469H44.1172ZM42.1016 13.3281C42.1016 13.0417 42.1953 12.8047 42.3828 12.6172C42.5755 12.4245 42.8411 12.3281 43.1797 12.3281C43.513 12.3281 43.776 12.4245 43.9688 12.6172C44.1615 12.8047 44.2578 13.0417 44.2578 13.3281C44.2578 13.6094 44.1615 13.8438 43.9688 14.0312C43.776 14.2188 43.513 14.3125 43.1797 14.3125C42.8411 14.3125 42.5755 14.2188 42.3828 14.0312C42.1953 13.8438 42.1016 13.6094 42.1016 13.3281ZM50.9453 22.3047V18.2734C50.9453 17.9714 50.8906 17.7109 50.7812 17.4922C50.6719 17.2734 50.5052 17.1042 50.2812 16.9844C50.0625 16.8646 49.7865 16.8047 49.4531 16.8047C49.1458 16.8047 48.8802 16.8568 48.6562 16.9609C48.4323 17.0651 48.2578 17.2057 48.1328 17.3828C48.0078 17.5599 47.9453 17.7604 47.9453 17.9844H46.0703C46.0703 17.651 46.151 17.3281 46.3125 17.0156C46.474 16.7031 46.7083 16.4245 47.0156 16.1797C47.3229 15.9349 47.6901 15.7422 48.1172 15.6016C48.5443 15.4609 49.0234 15.3906 49.5547 15.3906C50.1901 15.3906 50.7526 15.4974 51.2422 15.7109C51.737 15.9245 52.125 16.2474 52.4062 16.6797C52.6927 17.1068 52.8359 17.6432 52.8359 18.2891V22.0469C52.8359 22.4323 52.862 22.7786 52.9141 23.0859C52.9714 23.388 53.0521 23.651 53.1562 23.875V24H51.2266C51.138 23.7969 51.0677 23.5391 51.0156 23.2266C50.9688 22.9089 50.9453 22.6016 50.9453 22.3047ZM51.2188 18.8594L51.2344 20.0234H49.8828C49.5339 20.0234 49.2266 20.0573 48.9609 20.125C48.6953 20.1875 48.474 20.2812 48.2969 20.4062C48.1198 20.5312 47.987 20.6823 47.8984 20.8594C47.8099 21.0365 47.7656 21.237 47.7656 21.4609C47.7656 21.6849 47.8177 21.8906 47.9219 22.0781C48.026 22.2604 48.1771 22.4036 48.375 22.5078C48.5781 22.612 48.8229 22.6641 49.1094 22.6641C49.4948 22.6641 49.8307 22.5859 50.1172 22.4297C50.4089 22.2682 50.638 22.0729 50.8047 21.8438C50.9714 21.6094 51.0599 21.388 51.0703 21.1797L51.6797 22.0156C51.6172 22.2292 51.5104 22.4583 51.3594 22.7031C51.2083 22.9479 51.0104 23.1823 50.7656 23.4062C50.526 23.625 50.237 23.8047 49.8984 23.9453C49.5651 24.0859 49.1797 24.1562 48.7422 24.1562C48.1901 24.1562 47.6979 24.0469 47.2656 23.8281C46.8333 23.6042 46.4948 23.3047 46.25 22.9297C46.0052 22.5495 45.8828 22.1198 45.8828 21.6406C45.8828 21.1927 45.9661 20.7969 46.1328 20.4531C46.3047 20.1042 46.5547 19.8125 46.8828 19.5781C47.2161 19.3438 47.6224 19.1667 48.1016 19.0469C48.5807 18.9219 49.1276 18.8594 49.7422 18.8594H51.2188ZM50.3281 14.1484H48.9297L48.8594 13.0312C49.125 13.0156 49.3385 12.9896 49.5 12.9531C49.6615 12.9115 49.7786 12.8542 49.8516 12.7812C49.9297 12.7031 49.9688 12.6016 49.9688 12.4766C49.9688 12.3724 49.9375 12.2839 49.875 12.2109C49.8177 12.138 49.7344 12.0807 49.625 12.0391C49.5156 11.9922 49.388 11.9609 49.2422 11.9453C49.0964 11.9245 48.9375 11.9141 48.7656 11.9141L48.8203 10.9688C49.263 10.9688 49.651 11.0052 49.9844 11.0781C50.3229 11.1458 50.6042 11.2448 50.8281 11.375C51.0573 11.5052 51.2292 11.6615 51.3438 11.8438C51.4635 12.026 51.5234 12.2318 51.5234 12.4609C51.5234 12.8359 51.3984 13.112 51.1484 13.2891C50.8984 13.4661 50.625 13.5755 50.3281 13.6172V14.1484ZM56.6875 17.2656V24H54.8047V15.5469H56.5781L56.6875 17.2656ZM56.3828 19.4609L55.7422 19.4531C55.7422 18.8698 55.8151 18.3307 55.9609 17.8359C56.1068 17.3411 56.3203 16.9115 56.6016 16.5469C56.8828 16.1771 57.2318 15.8932 57.6484 15.6953C58.0703 15.4922 58.5573 15.3906 59.1094 15.3906C59.4948 15.3906 59.8464 15.4479 60.1641 15.5625C60.487 15.6719 60.7656 15.8464 61 16.0859C61.2396 16.3255 61.4219 16.6328 61.5469 17.0078C61.6771 17.3828 61.7422 17.8359 61.7422 18.3672V24H59.8594V18.5312C59.8594 18.1198 59.7969 17.7969 59.6719 17.5625C59.5521 17.3281 59.3776 17.1615 59.1484 17.0625C58.9245 16.9583 58.6562 16.9062 58.3438 16.9062C57.9896 16.9062 57.6875 16.974 57.4375 17.1094C57.1927 17.2448 56.9922 17.4297 56.8359 17.6641C56.6797 17.8984 56.5651 18.1693 56.4922 18.4766C56.4193 18.7839 56.3828 19.112 56.3828 19.4609ZM61.625 18.9609L60.7422 19.1562C60.7422 18.6458 60.8125 18.1641 60.9531 17.7109C61.099 17.2526 61.3099 16.8516 61.5859 16.5078C61.8672 16.1589 62.2135 15.8854 62.625 15.6875C63.0365 15.4896 63.5078 15.3906 64.0391 15.3906C64.4714 15.3906 64.8568 15.4505 65.1953 15.5703C65.5391 15.6849 65.8307 15.8672 66.0703 16.1172C66.3099 16.3672 66.4922 16.6927 66.6172 17.0938C66.7422 17.4896 66.8047 17.9688 66.8047 18.5312V24H64.9141V18.5234C64.9141 18.0964 64.8516 17.7656 64.7266 17.5312C64.6068 17.2969 64.4349 17.1354 64.2109 17.0469C63.987 16.9531 63.7188 16.9062 63.4062 16.9062C63.1146 16.9062 62.8568 16.9609 62.6328 17.0703C62.4141 17.1745 62.2292 17.3229 62.0781 17.5156C61.9271 17.7031 61.8125 17.9193 61.7344 18.1641C61.6615 18.4089 61.625 18.6745 61.625 18.9609Z"
                              fill="#EE4D2D"></path>
                            <path
                              d="M39.3281 47.7041V51H24.7383V48.1875L31.6377 40.79C32.3311 40.0186 32.8779 39.3398 33.2783 38.7539C33.6787 38.1582 33.9668 37.626 34.1426 37.1572C34.3281 36.6787 34.4209 36.2246 34.4209 35.7949C34.4209 35.1504 34.3135 34.5986 34.0986 34.1396C33.8838 33.6709 33.5664 33.3096 33.1465 33.0557C32.7363 32.8018 32.2285 32.6748 31.623 32.6748C30.9785 32.6748 30.4219 32.8311 29.9531 33.1436C29.4941 33.4561 29.1426 33.8906 28.8984 34.4473C28.6641 35.0039 28.5469 35.6338 28.5469 36.3369H24.3135C24.3135 35.0674 24.6162 33.9053 25.2217 32.8506C25.8271 31.7861 26.6816 30.9414 27.7852 30.3164C28.8887 29.6816 30.1973 29.3643 31.7109 29.3643C33.2051 29.3643 34.4648 29.6084 35.4902 30.0967C36.5254 30.5752 37.3066 31.2686 37.834 32.1768C38.3711 33.0752 38.6396 34.1494 38.6396 35.3994C38.6396 36.1025 38.5273 36.791 38.3027 37.4648C38.0781 38.1289 37.7559 38.793 37.3359 39.457C36.9258 40.1113 36.4277 40.7754 35.8418 41.4492C35.2559 42.123 34.6064 42.8213 33.8936 43.5439L30.1875 47.7041H39.3281ZM56.3203 38.4609V42.1523C56.3203 43.7539 56.1494 45.1357 55.8076 46.2979C55.4658 47.4502 54.9727 48.3975 54.3281 49.1396C53.6934 49.8721 52.9365 50.4141 52.0576 50.7656C51.1787 51.1172 50.2021 51.293 49.1279 51.293C48.2686 51.293 47.4678 51.1855 46.7256 50.9707C45.9834 50.7461 45.3145 50.3994 44.7188 49.9307C44.1328 49.4619 43.625 48.8711 43.1953 48.1582C42.7754 47.4355 42.4531 46.5762 42.2285 45.5801C42.0039 44.584 41.8916 43.4414 41.8916 42.1523V38.4609C41.8916 36.8594 42.0625 35.4873 42.4043 34.3447C42.7559 33.1924 43.249 32.25 43.8838 31.5176C44.5283 30.7852 45.29 30.248 46.1689 29.9062C47.0479 29.5547 48.0244 29.3789 49.0986 29.3789C49.958 29.3789 50.7539 29.4912 51.4863 29.7158C52.2285 29.9307 52.8975 30.2676 53.4932 30.7266C54.0889 31.1855 54.5967 31.7764 55.0166 32.499C55.4365 33.2119 55.7588 34.0664 55.9834 35.0625C56.208 36.0488 56.3203 37.1816 56.3203 38.4609ZM52.0869 42.709V37.8896C52.0869 37.1182 52.043 36.4443 51.9551 35.8682C51.877 35.292 51.7549 34.8037 51.5889 34.4033C51.4229 33.9932 51.2178 33.6611 50.9736 33.4072C50.7295 33.1533 50.4512 32.9678 50.1387 32.8506C49.8262 32.7334 49.4795 32.6748 49.0986 32.6748C48.6201 32.6748 48.1953 32.7676 47.8242 32.9531C47.4629 33.1387 47.1553 33.4365 46.9014 33.8467C46.6475 34.2471 46.4521 34.7842 46.3154 35.458C46.1885 36.1221 46.125 36.9326 46.125 37.8896V42.709C46.125 43.4805 46.1641 44.1592 46.2422 44.7451C46.3301 45.3311 46.457 45.834 46.623 46.2539C46.7988 46.6641 47.0039 47.001 47.2383 47.2646C47.4824 47.5186 47.7607 47.7041 48.0732 47.8213C48.3955 47.9385 48.7471 47.9971 49.1279 47.9971C49.5967 47.9971 50.0117 47.9043 50.373 47.7188C50.7441 47.5234 51.0566 47.2207 51.3105 46.8105C51.5742 46.3906 51.7695 45.8438 51.8965 45.1699C52.0234 44.4961 52.0869 43.6758 52.0869 42.709Z"
                              fill="#EE4D2D"></path>
                            <path
                              d="M61.1133 41.2676V40.5156C61.1133 39.9753 61.2305 39.4837 61.4648 39.041C61.6992 38.5983 62.041 38.2435 62.4902 37.9766C62.9395 37.7096 63.4798 37.5762 64.1113 37.5762C64.7624 37.5762 65.3092 37.7096 65.752 37.9766C66.2012 38.2435 66.543 38.5983 66.7773 39.041C67.0117 39.4837 67.1289 39.9753 67.1289 40.5156V41.2676C67.1289 41.7949 67.0117 42.2799 66.7773 42.7227C66.5495 43.1654 66.2109 43.5202 65.7617 43.7871C65.319 44.054 64.7754 44.1875 64.1309 44.1875C63.4928 44.1875 62.946 44.054 62.4902 43.7871C62.041 43.5202 61.6992 43.1654 61.4648 42.7227C61.2305 42.2799 61.1133 41.7949 61.1133 41.2676ZM62.7441 40.5156V41.2676C62.7441 41.528 62.793 41.7754 62.8906 42.0098C62.9948 42.2441 63.151 42.4329 63.3594 42.5762C63.5677 42.7194 63.8249 42.791 64.1309 42.791C64.4434 42.791 64.6973 42.7194 64.8926 42.5762C65.0944 42.4329 65.2441 42.2441 65.3418 42.0098C65.4395 41.7754 65.4883 41.528 65.4883 41.2676V40.5156C65.4883 40.2487 65.4362 39.998 65.332 39.7637C65.2344 39.5228 65.0846 39.3307 64.8828 39.1875C64.681 39.0443 64.4238 38.9727 64.1113 38.9727C63.8118 38.9727 63.5579 39.0443 63.3496 39.1875C63.1478 39.3307 62.9948 39.5228 62.8906 39.7637C62.793 39.998 62.7441 40.2487 62.7441 40.5156ZM67.9688 49.2754V48.5137C67.9688 47.9798 68.0859 47.4915 68.3203 47.0488C68.5612 46.6061 68.9062 46.2513 69.3555 45.9844C69.8047 45.7174 70.3451 45.584 70.9766 45.584C71.6276 45.584 72.1745 45.7174 72.6172 45.9844C73.0664 46.2513 73.4049 46.6061 73.6328 47.0488C73.8672 47.4915 73.9844 47.9798 73.9844 48.5137V49.2754C73.9844 49.8092 73.8672 50.2975 73.6328 50.7402C73.4049 51.1829 73.0697 51.5378 72.627 51.8047C72.1842 52.0716 71.6439 52.2051 71.0059 52.2051C70.3613 52.2051 69.8112 52.0716 69.3555 51.8047C68.9062 51.5378 68.5612 51.1829 68.3203 50.7402C68.0859 50.2975 67.9688 49.8092 67.9688 49.2754ZM69.6094 48.5137V49.2754C69.6094 49.5358 69.6615 49.7832 69.7656 50.0176C69.8763 50.252 70.0358 50.444 70.2441 50.5938C70.4525 50.737 70.7031 50.8086 70.9961 50.8086C71.3281 50.8086 71.5951 50.737 71.7969 50.5938C71.9987 50.444 72.1419 50.2552 72.2266 50.0273C72.3177 49.793 72.3633 49.5423 72.3633 49.2754V48.5137C72.3633 48.2467 72.3112 47.9961 72.207 47.7617C72.1094 47.5273 71.9564 47.3385 71.748 47.1953C71.5462 47.0521 71.2891 46.9805 70.9766 46.9805C70.6706 46.9805 70.4167 47.0521 70.2148 47.1953C70.013 47.3385 69.86 47.5273 69.7559 47.7617C69.6582 47.9961 69.6094 48.2467 69.6094 48.5137ZM71.5625 39.8125L64.6191 50.9258L63.418 50.2324L70.3613 39.1191L71.5625 39.8125Z"
                              fill="#EE4D2D"></path>
                            <rect x="8" y="70" width="82" height="20" rx="2" fill="#EE4D2D"></rect>
                            <path
                              d="M45.0332 83.0801V84H40.7676V83.0801H45.0332ZM40.9902 75.4688V84H39.8594V75.4688H40.9902ZM51.8418 77.1504H52.6738C52.6738 77.5762 52.6172 77.9336 52.5039 78.2227C52.3945 78.5117 52.2012 78.7285 51.9238 78.873C51.6465 79.0176 51.2559 79.0898 50.752 79.0898V78.4219C51.1035 78.4219 51.3555 78.3789 51.5078 78.293C51.6602 78.2031 51.7539 78.0645 51.7891 77.877C51.8242 77.6895 51.8418 77.4473 51.8418 77.1504ZM49.7852 82.5352V77.6602H50.875V84H49.8379L49.7852 82.5352ZM49.9902 81.1992L50.4414 81.1875C50.4414 81.6094 50.3965 82 50.3066 82.3594C50.2207 82.7148 50.0801 83.0234 49.8848 83.2852C49.6895 83.5469 49.4336 83.752 49.1172 83.9004C48.8008 84.0449 48.416 84.1172 47.9629 84.1172C47.6543 84.1172 47.3711 84.0723 47.1133 83.9824C46.8594 83.8926 46.6406 83.7539 46.457 83.5664C46.2734 83.3789 46.1309 83.1348 46.0293 82.834C45.9316 82.5332 45.8828 82.1719 45.8828 81.75V77.6602H46.9668V81.7617C46.9668 82.0469 46.998 82.2832 47.0605 82.4707C47.127 82.6543 47.2148 82.8008 47.3242 82.9102C47.4375 83.0156 47.5625 83.0898 47.6992 83.1328C47.8398 83.1758 47.9844 83.1973 48.1328 83.1973C48.5938 83.1973 48.959 83.1094 49.2285 82.9336C49.498 82.7539 49.6914 82.5137 49.8086 82.2129C49.9297 81.9082 49.9902 81.5703 49.9902 81.1992ZM57.2148 82.5352V77.6602H58.3047V84H57.2676L57.2148 82.5352ZM57.4199 81.1992L57.8711 81.1875C57.8711 81.6094 57.8262 82 57.7363 82.3594C57.6504 82.7148 57.5098 83.0234 57.3145 83.2852C57.1191 83.5469 56.8633 83.752 56.5469 83.9004C56.2305 84.0449 55.8457 84.1172 55.3926 84.1172C55.084 84.1172 54.8008 84.0723 54.543 83.9824C54.2891 83.8926 54.0703 83.7539 53.8867 83.5664C53.7031 83.3789 53.5605 83.1348 53.459 82.834C53.3613 82.5332 53.3125 82.1719 53.3125 81.75V77.6602H54.3965V81.7617C54.3965 82.0469 54.4277 82.2832 54.4902 82.4707C54.5566 82.6543 54.6445 82.8008 54.7539 82.9102C54.8672 83.0156 54.9922 83.0898 55.1289 83.1328C55.2695 83.1758 55.4141 83.1973 55.5625 83.1973C56.0234 83.1973 56.3887 83.1094 56.6582 82.9336C56.9277 82.7539 57.1211 82.5137 57.2383 82.2129C57.3594 81.9082 57.4199 81.5703 57.4199 81.1992Z"
                              fill="white"></path>
                          </svg>
                        </div>
                        <div v-else
                             style="width: 98px; min-width: 98px; height: 98px; position: relative; background-image: url('https://deo.shopeemobile.com/shopee/shopee-seller-live-sg/mmf_portal_seller_root_dir/static/modules/pas-shop/image/item_background.6ed3987.jpg');">
                          <div
                            style="position: absolute; background-color: rgba(0,0,0,.5); padding: 2px 4px; font-size: 10px; color: #fff; border-radius: 8px; top: 76px; left: 50%; transform: translateX(-50%)">
                            đ100.000
                          </div>
                        </div>

                        <div v-for="i in 4" :key="i"
                             style="width: 98px; min-width: 98px; height: 98px; position: relative; background-image: url('https://deo.shopeemobile.com/shopee/shopee-seller-live-sg/mmf_portal_seller_root_dir/static/modules/pas-shop/image/item_background.6ed3987.jpg');">
                          <div
                            style="position: absolute; background-color: rgba(0,0,0,.5); padding: 2px 4px; font-size: 10px; color: #fff; border-radius: 8px; top: 76px; left: 50%; transform: translateX(-50%)">
                            đ100.000
                          </div>

                          <div v-if="i === 1"
                               style="position:absolute;top:4px;right:0;display:inline;width:29px;height:16px;padding:2.5px 2px 1.5px 4px;font-size:10px;font-weight:500;line-height:12px;color:#fff;text-align:center;background:linear-gradient(180deg,#ee4d2d,#ff7337);border-radius:10px 0 0 10px;">
                            ~30%
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div>
                    <span style="color: #666">Trang web Shopee</span>
                  </div>
                  <div style="margin-top: 5px">
                    <div style="border: 1px solid #eee; border-radius: 4px; position: relative">
                      <div
                        style="padding: 10px; display: flex; gap: 10px; background-color: #fff; flex-wrap: nowrap; overflow: hidden">
                        <div style="flex: 1;padding: 10px; display: flex; flex-direction: column; gap: 5px">
                          <div style="display: flex; justify-content: center">
                            <img
                              :src="`https://cf.shopee.vn/file/${campaign_info.image_url}`"
                              alt="" style="width: 40px; height: 40px; object-fit: contain; border-radius: 50px">
                          </div>
                          <div style="text-align: center">
                            <div style="font-weight: 700; font-size: 8px">{{ shop.username.toUpperCase() }}</div>
                          </div>
                          <div style="display: flex; justify-content: center; gap: 5px">
                            <img
                              src="https://deo.shopeemobile.com/shopee/shopee-seller-live-sg/mmf_portal_seller_root_dir/static/modules/pas-shop/image/label_preferred_vn.d0af0b3.jpg"
                              alt="" style="height: 5px; object-fit: contain">

                            <div style="display: flex; align-items: center;">
                              <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
                                   style="width: 5px; height: 5px; fill: #eda500">
                                <path
                                  d="M8 12.854L4.213 14.94a.487.487 0 01-.672-.219.543.543 0 01-.05-.33l.723-4.418-3.064-3.13a.539.539 0 01-.009-.736.49.49 0 01.285-.152L5.66 5.31l1.894-4.02a.487.487 0 01.892 0l1.894 4.02 4.234.645c.272.041.46.306.42.59a.53.53 0 01-.144.299l-3.064 3.129.723 4.417a.52.52 0 01-.406.602.478.478 0 01-.316-.052L8 12.854z"></path>
                              </svg>
                              <span style="color: #eda500; font-size: 5px">
                                {{
                                  shop_preview_data && shop_preview_data.shop_rating ? shop_preview_data.shop_rating.toFixed(1) : 0
                                }}
                              </span>
                            </div>

                            <span style="font-size: 5px">
                              {{
                                shop_preview_data && shop_preview_data.rating_count ? shop_preview_data.rating_count : 0 | currency
                              }}
                              Đánh Giá
                            </span>
                          </div>
                          <div style="display: flex; justify-content: center; gap: 5px; margin-top: 5px">
                            <div
                              style="background-color: #fef6f5; color: #ee4d2d; border: 1px solid #ee4d2d; font-size: 6px; padding: 2px 5px; font-weight: bold">
                              Ghé Shop
                            </div>
                          </div>
                        </div>

                        <div v-for="i in 3" :key="i">
                          <div
                            style="width: 68px; min-width: 68px; height: 68px; position: relative; background-image: url('https://deo.shopeemobile.com/shopee/shopee-seller-live-sg/mmf_portal_seller_root_dir/static/modules/pas-shop/image/item_background.6ed3987.jpg'); background-size: cover">
                          </div>
                          <div style="font-size: 9px; margin-top: 5px">
                            Sản phẩm {{ i }}
                          </div>
                          <div style="display: flex; align-items: center; justify-content: space-between;">
                            <div style="font-size: 6px; color: orangered">
                              đ100,000
                            </div>
                            <div style="font-size: 6px;">
                              Đã bán 30
                            </div>
                          </div>
                        </div>

                        <div v-if="has_voucher === 'true'">
                          <svg viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg"
                               style="width: 68px; height: 68px">
                            <mask id="path-2-inside-1_1809_21315" fill="white">
                              <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M0 4C0 1.79086 1.79086 0 4 0H94C96.2091 0 98 1.79086 98 4V57C95.7909 57 94 58.7909 94 61C94 63.2091 95.7909 65 98 65V94C98 96.2091 96.2091 98 94 98H4C1.79086 98 0 96.2091 0 94V65C2.20914 65 4 63.2091 4 61C4 58.7909 2.20914 57 0 57V4Z"></path>
                            </mask>
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M0 4C0 1.79086 1.79086 0 4 0H94C96.2091 0 98 1.79086 98 4V57C95.7909 57 94 58.7909 94 61C94 63.2091 95.7909 65 98 65V94C98 96.2091 96.2091 98 94 98H4C1.79086 98 0 96.2091 0 94V65C2.20914 65 4 63.2091 4 61C4 58.7909 2.20914 57 0 57V4Z"
                                  fill="#FFF4F4"></path>
                            <path
                              d="M98 57V57.5H98.5V57H98ZM98 65H98.5V64.5H98V65ZM0 65V64.5H-0.5V65H0ZM0 57H-0.5V57.5H0V57ZM4 -0.5C1.51472 -0.5 -0.5 1.51472 -0.5 4H0.5C0.5 2.067 2.067 0.5 4 0.5V-0.5ZM94 -0.5H4V0.5H94V-0.5ZM98.5 4C98.5 1.51472 96.4853 -0.5 94 -0.5V0.5C95.933 0.5 97.5 2.067 97.5 4H98.5ZM98.5 57V4H97.5V57H98.5ZM94.5 61C94.5 59.067 96.067 57.5 98 57.5V56.5C95.5147 56.5 93.5 58.5147 93.5 61H94.5ZM98 64.5C96.067 64.5 94.5 62.933 94.5 61H93.5C93.5 63.4853 95.5147 65.5 98 65.5V64.5ZM98.5 94V65H97.5V94H98.5ZM94 98.5C96.4853 98.5 98.5 96.4853 98.5 94H97.5C97.5 95.933 95.933 97.5 94 97.5V98.5ZM4 98.5H94V97.5H4V98.5ZM-0.5 94C-0.5 96.4853 1.51472 98.5 4 98.5V97.5C2.067 97.5 0.5 95.933 0.5 94H-0.5ZM-0.5 65V94H0.5V65H-0.5ZM3.5 61C3.5 62.933 1.933 64.5 0 64.5V65.5C2.48528 65.5 4.5 63.4853 4.5 61H3.5ZM0 57.5C1.933 57.5 3.5 59.067 3.5 61H4.5C4.5 58.5147 2.48528 56.5 0 56.5V57.5ZM-0.5 4V57H0.5V4H-0.5Z"
                              fill="#EE4D2D" fill-opacity="0.15" mask="url(#path-2-inside-1_1809_21315)"></path>
                            <line x1="8" y1="60.75" x2="90" y2="60.75" stroke="#EE4D2D" stroke-opacity="0.15"
                                  stroke-width="0.5" stroke-dasharray="2 2"></line>
                            <path
                              d="M40.1172 18.1875V22.5312C39.9557 22.7448 39.7031 22.9792 39.3594 23.2344C39.0208 23.4844 38.5703 23.7005 38.0078 23.8828C37.4453 24.0651 36.7448 24.1562 35.9062 24.1562C35.1927 24.1562 34.5391 24.0365 33.9453 23.7969C33.3516 23.5521 32.8385 23.1953 32.4062 22.7266C31.9792 22.2578 31.6484 21.6875 31.4141 21.0156C31.1797 20.3385 31.0625 19.5677 31.0625 18.7031V17.9141C31.0625 17.0547 31.1693 16.2891 31.3828 15.6172C31.6016 14.9401 31.9141 14.3672 32.3203 13.8984C32.7266 13.4297 33.2161 13.0755 33.7891 12.8359C34.3672 12.5911 35.0208 12.4688 35.75 12.4688C36.6823 12.4688 37.4531 12.625 38.0625 12.9375C38.6771 13.2448 39.151 13.6719 39.4844 14.2188C39.8177 14.7656 40.0286 15.3906 40.1172 16.0938H38.1953C38.1328 15.6979 38.0104 15.3438 37.8281 15.0312C37.651 14.7188 37.3958 14.474 37.0625 14.2969C36.7344 14.1146 36.3073 14.0234 35.7812 14.0234C35.3281 14.0234 34.9297 14.1094 34.5859 14.2812C34.2422 14.4531 33.9557 14.7057 33.7266 15.0391C33.5026 15.3724 33.3333 15.7786 33.2188 16.2578C33.1042 16.737 33.0469 17.2839 33.0469 17.8984V18.7031C33.0469 19.3281 33.112 19.8828 33.2422 20.3672C33.3776 20.8516 33.5703 21.2604 33.8203 21.5938C34.0755 21.9271 34.3854 22.1797 34.75 22.3516C35.1146 22.5182 35.526 22.6016 35.9844 22.6016C36.4323 22.6016 36.7995 22.5651 37.0859 22.4922C37.3724 22.4141 37.599 22.3229 37.7656 22.2188C37.9375 22.1094 38.0703 22.0052 38.1641 21.9062V19.6484H35.7969V18.1875H40.1172ZM44.1172 15.5469V24H42.2266V15.5469H44.1172ZM42.1016 13.3281C42.1016 13.0417 42.1953 12.8047 42.3828 12.6172C42.5755 12.4245 42.8411 12.3281 43.1797 12.3281C43.513 12.3281 43.776 12.4245 43.9688 12.6172C44.1615 12.8047 44.2578 13.0417 44.2578 13.3281C44.2578 13.6094 44.1615 13.8438 43.9688 14.0312C43.776 14.2188 43.513 14.3125 43.1797 14.3125C42.8411 14.3125 42.5755 14.2188 42.3828 14.0312C42.1953 13.8438 42.1016 13.6094 42.1016 13.3281ZM50.9453 22.3047V18.2734C50.9453 17.9714 50.8906 17.7109 50.7812 17.4922C50.6719 17.2734 50.5052 17.1042 50.2812 16.9844C50.0625 16.8646 49.7865 16.8047 49.4531 16.8047C49.1458 16.8047 48.8802 16.8568 48.6562 16.9609C48.4323 17.0651 48.2578 17.2057 48.1328 17.3828C48.0078 17.5599 47.9453 17.7604 47.9453 17.9844H46.0703C46.0703 17.651 46.151 17.3281 46.3125 17.0156C46.474 16.7031 46.7083 16.4245 47.0156 16.1797C47.3229 15.9349 47.6901 15.7422 48.1172 15.6016C48.5443 15.4609 49.0234 15.3906 49.5547 15.3906C50.1901 15.3906 50.7526 15.4974 51.2422 15.7109C51.737 15.9245 52.125 16.2474 52.4062 16.6797C52.6927 17.1068 52.8359 17.6432 52.8359 18.2891V22.0469C52.8359 22.4323 52.862 22.7786 52.9141 23.0859C52.9714 23.388 53.0521 23.651 53.1562 23.875V24H51.2266C51.138 23.7969 51.0677 23.5391 51.0156 23.2266C50.9688 22.9089 50.9453 22.6016 50.9453 22.3047ZM51.2188 18.8594L51.2344 20.0234H49.8828C49.5339 20.0234 49.2266 20.0573 48.9609 20.125C48.6953 20.1875 48.474 20.2812 48.2969 20.4062C48.1198 20.5312 47.987 20.6823 47.8984 20.8594C47.8099 21.0365 47.7656 21.237 47.7656 21.4609C47.7656 21.6849 47.8177 21.8906 47.9219 22.0781C48.026 22.2604 48.1771 22.4036 48.375 22.5078C48.5781 22.612 48.8229 22.6641 49.1094 22.6641C49.4948 22.6641 49.8307 22.5859 50.1172 22.4297C50.4089 22.2682 50.638 22.0729 50.8047 21.8438C50.9714 21.6094 51.0599 21.388 51.0703 21.1797L51.6797 22.0156C51.6172 22.2292 51.5104 22.4583 51.3594 22.7031C51.2083 22.9479 51.0104 23.1823 50.7656 23.4062C50.526 23.625 50.237 23.8047 49.8984 23.9453C49.5651 24.0859 49.1797 24.1562 48.7422 24.1562C48.1901 24.1562 47.6979 24.0469 47.2656 23.8281C46.8333 23.6042 46.4948 23.3047 46.25 22.9297C46.0052 22.5495 45.8828 22.1198 45.8828 21.6406C45.8828 21.1927 45.9661 20.7969 46.1328 20.4531C46.3047 20.1042 46.5547 19.8125 46.8828 19.5781C47.2161 19.3438 47.6224 19.1667 48.1016 19.0469C48.5807 18.9219 49.1276 18.8594 49.7422 18.8594H51.2188ZM50.3281 14.1484H48.9297L48.8594 13.0312C49.125 13.0156 49.3385 12.9896 49.5 12.9531C49.6615 12.9115 49.7786 12.8542 49.8516 12.7812C49.9297 12.7031 49.9688 12.6016 49.9688 12.4766C49.9688 12.3724 49.9375 12.2839 49.875 12.2109C49.8177 12.138 49.7344 12.0807 49.625 12.0391C49.5156 11.9922 49.388 11.9609 49.2422 11.9453C49.0964 11.9245 48.9375 11.9141 48.7656 11.9141L48.8203 10.9688C49.263 10.9688 49.651 11.0052 49.9844 11.0781C50.3229 11.1458 50.6042 11.2448 50.8281 11.375C51.0573 11.5052 51.2292 11.6615 51.3438 11.8438C51.4635 12.026 51.5234 12.2318 51.5234 12.4609C51.5234 12.8359 51.3984 13.112 51.1484 13.2891C50.8984 13.4661 50.625 13.5755 50.3281 13.6172V14.1484ZM56.6875 17.2656V24H54.8047V15.5469H56.5781L56.6875 17.2656ZM56.3828 19.4609L55.7422 19.4531C55.7422 18.8698 55.8151 18.3307 55.9609 17.8359C56.1068 17.3411 56.3203 16.9115 56.6016 16.5469C56.8828 16.1771 57.2318 15.8932 57.6484 15.6953C58.0703 15.4922 58.5573 15.3906 59.1094 15.3906C59.4948 15.3906 59.8464 15.4479 60.1641 15.5625C60.487 15.6719 60.7656 15.8464 61 16.0859C61.2396 16.3255 61.4219 16.6328 61.5469 17.0078C61.6771 17.3828 61.7422 17.8359 61.7422 18.3672V24H59.8594V18.5312C59.8594 18.1198 59.7969 17.7969 59.6719 17.5625C59.5521 17.3281 59.3776 17.1615 59.1484 17.0625C58.9245 16.9583 58.6562 16.9062 58.3438 16.9062C57.9896 16.9062 57.6875 16.974 57.4375 17.1094C57.1927 17.2448 56.9922 17.4297 56.8359 17.6641C56.6797 17.8984 56.5651 18.1693 56.4922 18.4766C56.4193 18.7839 56.3828 19.112 56.3828 19.4609ZM61.625 18.9609L60.7422 19.1562C60.7422 18.6458 60.8125 18.1641 60.9531 17.7109C61.099 17.2526 61.3099 16.8516 61.5859 16.5078C61.8672 16.1589 62.2135 15.8854 62.625 15.6875C63.0365 15.4896 63.5078 15.3906 64.0391 15.3906C64.4714 15.3906 64.8568 15.4505 65.1953 15.5703C65.5391 15.6849 65.8307 15.8672 66.0703 16.1172C66.3099 16.3672 66.4922 16.6927 66.6172 17.0938C66.7422 17.4896 66.8047 17.9688 66.8047 18.5312V24H64.9141V18.5234C64.9141 18.0964 64.8516 17.7656 64.7266 17.5312C64.6068 17.2969 64.4349 17.1354 64.2109 17.0469C63.987 16.9531 63.7188 16.9062 63.4062 16.9062C63.1146 16.9062 62.8568 16.9609 62.6328 17.0703C62.4141 17.1745 62.2292 17.3229 62.0781 17.5156C61.9271 17.7031 61.8125 17.9193 61.7344 18.1641C61.6615 18.4089 61.625 18.6745 61.625 18.9609Z"
                              fill="#EE4D2D"></path>
                            <path
                              d="M39.3281 47.7041V51H24.7383V48.1875L31.6377 40.79C32.3311 40.0186 32.8779 39.3398 33.2783 38.7539C33.6787 38.1582 33.9668 37.626 34.1426 37.1572C34.3281 36.6787 34.4209 36.2246 34.4209 35.7949C34.4209 35.1504 34.3135 34.5986 34.0986 34.1396C33.8838 33.6709 33.5664 33.3096 33.1465 33.0557C32.7363 32.8018 32.2285 32.6748 31.623 32.6748C30.9785 32.6748 30.4219 32.8311 29.9531 33.1436C29.4941 33.4561 29.1426 33.8906 28.8984 34.4473C28.6641 35.0039 28.5469 35.6338 28.5469 36.3369H24.3135C24.3135 35.0674 24.6162 33.9053 25.2217 32.8506C25.8271 31.7861 26.6816 30.9414 27.7852 30.3164C28.8887 29.6816 30.1973 29.3643 31.7109 29.3643C33.2051 29.3643 34.4648 29.6084 35.4902 30.0967C36.5254 30.5752 37.3066 31.2686 37.834 32.1768C38.3711 33.0752 38.6396 34.1494 38.6396 35.3994C38.6396 36.1025 38.5273 36.791 38.3027 37.4648C38.0781 38.1289 37.7559 38.793 37.3359 39.457C36.9258 40.1113 36.4277 40.7754 35.8418 41.4492C35.2559 42.123 34.6064 42.8213 33.8936 43.5439L30.1875 47.7041H39.3281ZM56.3203 38.4609V42.1523C56.3203 43.7539 56.1494 45.1357 55.8076 46.2979C55.4658 47.4502 54.9727 48.3975 54.3281 49.1396C53.6934 49.8721 52.9365 50.4141 52.0576 50.7656C51.1787 51.1172 50.2021 51.293 49.1279 51.293C48.2686 51.293 47.4678 51.1855 46.7256 50.9707C45.9834 50.7461 45.3145 50.3994 44.7188 49.9307C44.1328 49.4619 43.625 48.8711 43.1953 48.1582C42.7754 47.4355 42.4531 46.5762 42.2285 45.5801C42.0039 44.584 41.8916 43.4414 41.8916 42.1523V38.4609C41.8916 36.8594 42.0625 35.4873 42.4043 34.3447C42.7559 33.1924 43.249 32.25 43.8838 31.5176C44.5283 30.7852 45.29 30.248 46.1689 29.9062C47.0479 29.5547 48.0244 29.3789 49.0986 29.3789C49.958 29.3789 50.7539 29.4912 51.4863 29.7158C52.2285 29.9307 52.8975 30.2676 53.4932 30.7266C54.0889 31.1855 54.5967 31.7764 55.0166 32.499C55.4365 33.2119 55.7588 34.0664 55.9834 35.0625C56.208 36.0488 56.3203 37.1816 56.3203 38.4609ZM52.0869 42.709V37.8896C52.0869 37.1182 52.043 36.4443 51.9551 35.8682C51.877 35.292 51.7549 34.8037 51.5889 34.4033C51.4229 33.9932 51.2178 33.6611 50.9736 33.4072C50.7295 33.1533 50.4512 32.9678 50.1387 32.8506C49.8262 32.7334 49.4795 32.6748 49.0986 32.6748C48.6201 32.6748 48.1953 32.7676 47.8242 32.9531C47.4629 33.1387 47.1553 33.4365 46.9014 33.8467C46.6475 34.2471 46.4521 34.7842 46.3154 35.458C46.1885 36.1221 46.125 36.9326 46.125 37.8896V42.709C46.125 43.4805 46.1641 44.1592 46.2422 44.7451C46.3301 45.3311 46.457 45.834 46.623 46.2539C46.7988 46.6641 47.0039 47.001 47.2383 47.2646C47.4824 47.5186 47.7607 47.7041 48.0732 47.8213C48.3955 47.9385 48.7471 47.9971 49.1279 47.9971C49.5967 47.9971 50.0117 47.9043 50.373 47.7188C50.7441 47.5234 51.0566 47.2207 51.3105 46.8105C51.5742 46.3906 51.7695 45.8438 51.8965 45.1699C52.0234 44.4961 52.0869 43.6758 52.0869 42.709Z"
                              fill="#EE4D2D"></path>
                            <path
                              d="M61.1133 41.2676V40.5156C61.1133 39.9753 61.2305 39.4837 61.4648 39.041C61.6992 38.5983 62.041 38.2435 62.4902 37.9766C62.9395 37.7096 63.4798 37.5762 64.1113 37.5762C64.7624 37.5762 65.3092 37.7096 65.752 37.9766C66.2012 38.2435 66.543 38.5983 66.7773 39.041C67.0117 39.4837 67.1289 39.9753 67.1289 40.5156V41.2676C67.1289 41.7949 67.0117 42.2799 66.7773 42.7227C66.5495 43.1654 66.2109 43.5202 65.7617 43.7871C65.319 44.054 64.7754 44.1875 64.1309 44.1875C63.4928 44.1875 62.946 44.054 62.4902 43.7871C62.041 43.5202 61.6992 43.1654 61.4648 42.7227C61.2305 42.2799 61.1133 41.7949 61.1133 41.2676ZM62.7441 40.5156V41.2676C62.7441 41.528 62.793 41.7754 62.8906 42.0098C62.9948 42.2441 63.151 42.4329 63.3594 42.5762C63.5677 42.7194 63.8249 42.791 64.1309 42.791C64.4434 42.791 64.6973 42.7194 64.8926 42.5762C65.0944 42.4329 65.2441 42.2441 65.3418 42.0098C65.4395 41.7754 65.4883 41.528 65.4883 41.2676V40.5156C65.4883 40.2487 65.4362 39.998 65.332 39.7637C65.2344 39.5228 65.0846 39.3307 64.8828 39.1875C64.681 39.0443 64.4238 38.9727 64.1113 38.9727C63.8118 38.9727 63.5579 39.0443 63.3496 39.1875C63.1478 39.3307 62.9948 39.5228 62.8906 39.7637C62.793 39.998 62.7441 40.2487 62.7441 40.5156ZM67.9688 49.2754V48.5137C67.9688 47.9798 68.0859 47.4915 68.3203 47.0488C68.5612 46.6061 68.9062 46.2513 69.3555 45.9844C69.8047 45.7174 70.3451 45.584 70.9766 45.584C71.6276 45.584 72.1745 45.7174 72.6172 45.9844C73.0664 46.2513 73.4049 46.6061 73.6328 47.0488C73.8672 47.4915 73.9844 47.9798 73.9844 48.5137V49.2754C73.9844 49.8092 73.8672 50.2975 73.6328 50.7402C73.4049 51.1829 73.0697 51.5378 72.627 51.8047C72.1842 52.0716 71.6439 52.2051 71.0059 52.2051C70.3613 52.2051 69.8112 52.0716 69.3555 51.8047C68.9062 51.5378 68.5612 51.1829 68.3203 50.7402C68.0859 50.2975 67.9688 49.8092 67.9688 49.2754ZM69.6094 48.5137V49.2754C69.6094 49.5358 69.6615 49.7832 69.7656 50.0176C69.8763 50.252 70.0358 50.444 70.2441 50.5938C70.4525 50.737 70.7031 50.8086 70.9961 50.8086C71.3281 50.8086 71.5951 50.737 71.7969 50.5938C71.9987 50.444 72.1419 50.2552 72.2266 50.0273C72.3177 49.793 72.3633 49.5423 72.3633 49.2754V48.5137C72.3633 48.2467 72.3112 47.9961 72.207 47.7617C72.1094 47.5273 71.9564 47.3385 71.748 47.1953C71.5462 47.0521 71.2891 46.9805 70.9766 46.9805C70.6706 46.9805 70.4167 47.0521 70.2148 47.1953C70.013 47.3385 69.86 47.5273 69.7559 47.7617C69.6582 47.9961 69.6094 48.2467 69.6094 48.5137ZM71.5625 39.8125L64.6191 50.9258L63.418 50.2324L70.3613 39.1191L71.5625 39.8125Z"
                              fill="#EE4D2D"></path>
                            <rect x="8" y="70" width="82" height="20" rx="2" fill="#EE4D2D"></rect>
                            <path
                              d="M45.0332 83.0801V84H40.7676V83.0801H45.0332ZM40.9902 75.4688V84H39.8594V75.4688H40.9902ZM51.8418 77.1504H52.6738C52.6738 77.5762 52.6172 77.9336 52.5039 78.2227C52.3945 78.5117 52.2012 78.7285 51.9238 78.873C51.6465 79.0176 51.2559 79.0898 50.752 79.0898V78.4219C51.1035 78.4219 51.3555 78.3789 51.5078 78.293C51.6602 78.2031 51.7539 78.0645 51.7891 77.877C51.8242 77.6895 51.8418 77.4473 51.8418 77.1504ZM49.7852 82.5352V77.6602H50.875V84H49.8379L49.7852 82.5352ZM49.9902 81.1992L50.4414 81.1875C50.4414 81.6094 50.3965 82 50.3066 82.3594C50.2207 82.7148 50.0801 83.0234 49.8848 83.2852C49.6895 83.5469 49.4336 83.752 49.1172 83.9004C48.8008 84.0449 48.416 84.1172 47.9629 84.1172C47.6543 84.1172 47.3711 84.0723 47.1133 83.9824C46.8594 83.8926 46.6406 83.7539 46.457 83.5664C46.2734 83.3789 46.1309 83.1348 46.0293 82.834C45.9316 82.5332 45.8828 82.1719 45.8828 81.75V77.6602H46.9668V81.7617C46.9668 82.0469 46.998 82.2832 47.0605 82.4707C47.127 82.6543 47.2148 82.8008 47.3242 82.9102C47.4375 83.0156 47.5625 83.0898 47.6992 83.1328C47.8398 83.1758 47.9844 83.1973 48.1328 83.1973C48.5938 83.1973 48.959 83.1094 49.2285 82.9336C49.498 82.7539 49.6914 82.5137 49.8086 82.2129C49.9297 81.9082 49.9902 81.5703 49.9902 81.1992ZM57.2148 82.5352V77.6602H58.3047V84H57.2676L57.2148 82.5352ZM57.4199 81.1992L57.8711 81.1875C57.8711 81.6094 57.8262 82 57.7363 82.3594C57.6504 82.7148 57.5098 83.0234 57.3145 83.2852C57.1191 83.5469 56.8633 83.752 56.5469 83.9004C56.2305 84.0449 55.8457 84.1172 55.3926 84.1172C55.084 84.1172 54.8008 84.0723 54.543 83.9824C54.2891 83.8926 54.0703 83.7539 53.8867 83.5664C53.7031 83.3789 53.5605 83.1348 53.459 82.834C53.3613 82.5332 53.3125 82.1719 53.3125 81.75V77.6602H54.3965V81.7617C54.3965 82.0469 54.4277 82.2832 54.4902 82.4707C54.5566 82.6543 54.6445 82.8008 54.7539 82.9102C54.8672 83.0156 54.9922 83.0898 55.1289 83.1328C55.2695 83.1758 55.4141 83.1973 55.5625 83.1973C56.0234 83.1973 56.3887 83.1094 56.6582 82.9336C56.9277 82.7539 57.1211 82.5137 57.2383 82.2129C57.3594 81.9082 57.4199 81.5703 57.4199 81.1992Z"
                              fill="white"></path>
                          </svg>
                        </div>
                        <div v-else>
                          <div
                            style="width: 68px; min-width: 68px; height: 68px; position: relative; background-image: url('https://deo.shopeemobile.com/shopee/shopee-seller-live-sg/mmf_portal_seller_root_dir/static/modules/pas-shop/image/item_background.6ed3987.jpg'); background-size: cover">
                          </div>
                          <div style="font-size: 9px; margin-top: 5px">
                            Sản phẩm 4
                          </div>
                          <div style="display: flex; align-items: center; justify-content: space-between;">
                            <div style="font-size: 6px; color: orangered">
                              đ100,000
                            </div>
                            <div style="font-size: 6px;">
                              Đã bán 30
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        style="position:absolute;right:0;bottom:0;display:flex;align-items:center;justify-content:center;padding:1px 2px;font-size:6px;line-height:8px;color:#fff;background:rgba(0,0,0,.26);border-top-left-radius:4px;">
                        Ad
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="margin: 50px 0" class="text-right">
      <el-button type="primary" size="medium" :loading="loading.create_campaign" icon="el-icon-check"
                 @click="m__confirm_create_new_product_campaign">{{ $t('base.create_new_campaign') }}
      </el-button>
    </div>

    <el-dialog :visible.sync="show_dialog.select_product" :close-on-click-modal="false"
               width="1000px">
      <div slot="title" style="padding: 0 10px 10px 10px">
        <strong style="font-size: 15px">
          {{ $t('ads.select_products_for_creating_ad').toUpperCase() }}
          <span v-if="!get_products" class="text-success">({{ $t('product.get_success') }})</span>
          <span v-else class="text-warning">(<i class="el-icon-loading"></i> {{ $t('base.loading_data') }}...)</span>
        </strong>
        <br>
        <br>

        <el-row>
          <el-col :sm="18">
            {{ $t('product.list') }} ({{ $t('base.selected') }} {{
              c__product_filter_list.filter(i => i.checked).length
            }})
          </el-col>
          <el-col :sm="6">
            <el-input size="mini" v-model="product_filter.keyword" :placeholder="$t('input.placeholder')"></el-input>
          </el-col>
        </el-row>

        <br>
        <el-table :data="c__product_display_list" @sort-change="m__product_sort_change"
                  @row-click="(row, column) => {if (column.label !== '#') {row.checked = !row.checked}}">
          <el-table-column label="#" width="40px">
            <template slot-scope="scope">
              <el-checkbox size="mini" v-model="scope.row.checked"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.image')" width="50px">
            <template slot-scope="scope">
              <template v-if="scope.row.images.length>0">
                <img :src="SHOPEE_IMAGE(scope.row.images.split(',')[0])" alt="product_logo"
                     style="width:32px; height:32px; border-radius: 4px;"/>
              </template>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.product')" prop="name" show-tooltip-when-overflow>
            <template slot-scope="scope">
              <a href="javascript:void(0)"
                 @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${scope.row.id}`, shop)">
                {{ scope.row.name }}
              </a>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.price')" prop="price" width="100px" sortable="custom">
            <template slot-scope="scope">
              {{ scope.row.price | currency }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.monthly_sales')" prop="monthly_sales" width="130px" sortable="custom">
          </el-table-column>
          <el-table-column :label="$t('base.sales')" prop="revenue" width="130px" sortable="custom">
            <template slot-scope="scope">
              {{ scope.row.revenue | currency }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.stock')" prop="stock" width="100px" sortable="custom">
          </el-table-column>
        </el-table>
        <br>
        <el-row>
          <el-col :sm="12">
            <el-pagination :current-page.sync="product_filter.current_page" :page-size="product_filter.page_size"
                           layout="prev, pager, next, total" :total="c__product_filter_list.length"/>
          </el-col>
          <el-col :sm="12" class="text-right">
            <el-button size="mini" type="primary" @click="m__confirm_select_product" icon="el-icon-check">
              {{ $t('base.confirm') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.shopee_result" :close-on-click-modal="false" custom-class="no-body"
               width="700px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('ads.create_campaigns_result') }}</strong>

        <div>
          <el-table :data="create_campaigns_result">
            <el-table-column :label="$t('base.product')" show-tooltip-when-overflow>
              <template slot-scope="scope">{{ scope.row.name }}</template>
            </el-table-column>
            <el-table-column :label="$t('base.status')">
              <template slot-scope="scope">
                <div v-if="scope.row.code === 0">
                  <strong class="text-success">{{ $t('base.create_campaign_success') }}</strong>
                </div>
                <div v-else>
                  <strong class="text-danger">{{ $t('ads.cannot_create_campaign') }}</strong>
                  <br>
                  <strong class="text-danger"> {{ $t('base.error_code') }}: {{ scope.row.code }}</strong>
                  <br>
                  <div v-for="item in scope.row.validation_error_list">
                    <strong v-if="typeof item === 'string'">{{ item }}</strong>
                    <strong v-if="typeof item === 'object'">field: {{ item.field }} - msg: {{ item.msg }}</strong>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div style="margin-top: 30px" class="text-right">
          <el-button
            v-if="create_campaigns_result.filter(i => i.code === 0).length === create_campaigns_result.length"
            size="mini" type="primary" @click="show_dialog.shopee_result = false; m__back_to_list()">
            {{ $t('ads.back_to_campaigns') }}
          </el-button>
          <el-button size="mini" type="default" icon="el-icon-close" @click="show_dialog.shopee_result = false">
            {{ $t('base.close') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_keyword_price" :close-on-click-modal="false"
               width="800px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title"> {{ $t('base.mass_edit_x', {x: $t('base.bid_price')}) }} </strong>

        <el-row>
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_keyword_price.update_type" :label="1">
              {{ $t('base.i_or_d_x_by_amount', {x: $t('base.bid_price')}) }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-row>
              <el-col :sm="12">
                <el-select size="mini" v-model="form_update_multiple_keyword_price.update_by_cost" class="full-w"
                           :disabled="form_update_multiple_keyword_price.update_type !== 1">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="12">
                <el-input size="mini" type="number" :disabled="form_update_multiple_keyword_price.update_type !== 1"
                          v-model="form_update_multiple_keyword_price.update_by_cost_value"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_keyword_price.update_type" :label="2">
              {{ $t('base.i_or_d_x_by_percent', {x: $t('base.bid_price')}) }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-row>
              <el-col :sm="12">
                <el-select size="mini" v-model="form_update_multiple_keyword_price.update_by_percent" class="full-w"
                           :disabled="form_update_multiple_keyword_price.update_type !== 2">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="12">
                <el-input size="mini" type="number" :disabled="form_update_multiple_keyword_price.update_type !== 2"
                          v-model="form_update_multiple_keyword_price.update_by_percent_value"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_keyword_price.update_type" :label="3">
              {{ $t('base.set_x', {x: $t('base.bid_price')}) }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-row>
              <el-col :sm="12">
                &nbsp;
              </el-col>
              <el-col :sm="12">
                <el-input size="mini" type="number" :disabled="form_update_multiple_keyword_price.update_type !== 3"
                          v-model="form_update_multiple_keyword_price.price"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <div style="margin-top: 10px" class="text-right">
          <el-button size="mini" type="primary" icon="el-icon-check" @click="m__update_keyword_price">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="save_keyword_file.show" :close-on-click-modal="false" custom-class="no-body"
               width="400px">
      <div slot="title" style="padding:10px">
        <p class="text-title">{{ $t('base.filename') }}</p>
        <el-input size="mini" :placeholder="$t('input.filename')"
                  v-model="save_keyword_file.filename"></el-input>
        <div style="padding-top:20px;" class="text-right">
          <el-button size="mini" icon="el-icon-close" @click="save_keyword_file.show=false">{{
              $t('base.close')
            }}
          </el-button>
          <el-button size="mini" icon="ti-save" :loading="save_keyword_file.loading" type="primary"
                     @click="m__try_save_keyword_file"> &nbsp; {{ $t('base.save_file') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.preview_ads" :close-on-click-modal="false" custom-class="no-body"
               width="840px">
      <div slot="title" style="padding: 20px">
        <p style="font-size: 16px; font-weight: bold">{{ 'Xem trước vị trí quảng cáo' }}</p>

        <div style="display: flex; gap: 20px; margin: 30px 0;">
          <div style="width: 200px">
            <div style="text-align: center">
              <strong style="font-size: 14px">Ứng dụng Shopee</strong>
            </div>
            <div style="width: 100%; margin-top: 10px">
              <img
                src="https://deo.shopeemobile.com/shopee/shopee-seller-live-sg/mmf_portal_seller_root_dir/static/modules/pas-shop/image/default_preview_app_vi.2cb8c3b.jpg"
                alt="" style="width: 100%; object-fit: contain">
            </div>
          </div>

          <div style="width: 570px">
            <div style="text-align: center">
              <strong style="font-size: 14px">Trang web Shopee</strong>
            </div>
            <div style="width: 100%; margin-top: 10px">
              <img
                src="https://deo.shopeemobile.com/shopee/shopee-seller-live-sg/mmf_portal_seller_root_dir/static/modules/pas-shop/image/default_preview_pc_vi.9d364be.jpg"
                alt="" style="width: 100%; object-fit: contain">
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <input accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" type="file"
           @change="m__import_excel_file" id="input_control_create" style="display: none;">

    <input accept="image/*" type="file" id="input_shop_ads_image" style="display: none;"
           @change="m__upload_shop_ads_image">
  </div>
</template>

<script>
import {orderBy as _orderBy, drop as _drop, take as _take, uniqBy as _uniqBy} from 'lodash'
import {FFF_COM_VN} from '../../../addon/fff'
import readXlsxFile from 'read-excel-file'
import {ADS_CONSTANTS, make_uuid} from '../../../addon/ads_function'
import {fix_ads_mixins} from "../../../mixins/fix_ads";
import {package_mixins} from "../../../mixins/package";

export default {
  mixins: [fix_ads_mixins, package_mixins],

  props: {
    shop: {},
    sp_user: {},
    product_list: {},
    get_products: false,
    ads_config: {},
    fff: null
  },

  data() {
    return {
      campaign_info: {
        name: this.$t('ads.shop_ads') + ' ' + this.dayjs().format('YYYY-MM-DD'),
        tagline: '',
        budget_type: 'unlimited',
        daily_budget: 0,
        campaign_time: 'unlimited',
        campaign_date_range: [new Date(), new Date()],
        campaign_type: 'all',
        add_price_type: 'mipee',
        keyword_match_type: 'exact',
        image_url: ''
      },

      add_product_type: 'manual',
      config_campaign_price_type: 'manual',
      config_campaign_creative: 'default',

      product_filter: {
        page_size: 10,
        current_page: 0,
        keyword: '',
        total_record: 0,
        show: true
      },
      product_sort_option: {
        order: null,
        prop: null
      },

      product_selected_list: [],

      show_dialog: {
        select_product: false,
        update_keyword_price: false,
        shopee_result: false,
        preview_ads: false
      },
      loading: {
        create_campaign: false,
        shopee_suggest_keywords: false
      },

      advertisements: [
        {
          extinfo: {
            target: {
              price: null,
              base_price: null,
              premium_rate: 0
            }
          },
          itemid: '',
          placement: 2,
          rate: 0,
          status: 1
        },
        {
          extinfo: {
            target: {
              price: null,
              base_price: null,
              premium_rate: 0
            }
          },
          itemid: '',
          placement: 5,
          rate: 0,
          status: 1
        }
      ],

      form_update_target_broad_roi: {
        type: 'auto',
        custom_type: 'custom',
        custom_type_list: [6.1 * 100000, 9.1 * 100000, 11 * 100000],
        custom_value: null
      },

      // todo: old create search campaign data
      fff_sort_option: {
        order: null,
        prop: null
      },
      keyword_file_list: [],
      keyword: '',
      selected_keyword_file: '',
      mipee_suggest_keywords: [],
      shopee_suggest_keywords: [],
      mipee_filter: {
        page_size: 10,
        current_page: 0,
        sort_option: {
          order: null,
          prop: null
        },
      },
      shopee_filter: {
        page_size: 10,
        current_page: 0,
        sort_option: {
          order: null,
          prop: null
        },
      },
      type_product: 'all',
      category_list: [],
      selected_category: null,
      shop_category_list: [],
      selected_shop_category: null,
      radio: '1',
      search_keyword: [],
      search_keyword_filter: {
        page_size: 10,
        current_page: 0,
        sort_option: {
          order: null,
          prop: null
        },
      },
      atosa_keyword_filter: {
        page_size: 10,
        current_page: 0
      },
      added_keyword: [],
      added_keyword_filter: {
        page_size: 10,
        current_page: 0
      },
      form_update_multiple_keyword_price: {
        update_type: 3,
        update_by_cost: 'increase',
        update_by_percent: 'increase',
        update_by_suggest_cost: 'increase',
        update_by_suggest_percent: 'increase',
        update_by_cost_value: 0,
        update_by_percent_value: 0,
        update_by_suggest_cost_value: 1,
        update_by_suggest_percent_value: 1,
        cost_value: 0,
        match_type: 1,
        price: 0
      },
      base_keyword: '',
      fff_loading: false,
      fff_profile: {},
      fff_show: true,
      fff_result: [],
      fetch_loading: false,
      fetch_keyword: '',
      fff_clone: [],
      save_keyword_file: {
        show: false,
        loading: false,
        filename: 'Tệp keyword'
      },
      excel_keyword_filter: {
        page_size: 10,
        current_page: 0
      },
      excel_keyword: [],
      save_and_result_list: [],
      omit_duplicated_keyword: false,

      MATCH_TYPE_0_MIN: null, // TODO: exact
      MATCH_TYPE_1_MIN: null, // TODO: broad

      shopee_result: [],

      form_add_new_campaign: {
        price_type: 'shopee',
        match_type: 0
      },

      create_campaigns_result: [],

      bidding_strategy_eligibility: {},

      shop_preview_data: {},

      has_voucher: 'true'
    }
  },

  async beforeMount() {
    await this.m__get_keyword_file()
    await this.m__get_shopee_suggest_keywords()
    await this.m__get_preview_data()
    await this.m__get_bidding_strategy_eligibility()

    // todo: set ads config
    if (this.ads_config && this.ads_config.bid_price) {
      this.MATCH_TYPE_0_MIN = this.m__calculate(this.ads_config.bid_price.search_shop.exact_match.min / 100000)
      this.MATCH_TYPE_1_MIN = this.m__calculate(this.ads_config.bid_price.search_shop.broad_match.min / 100000)
      this.TARGETING_MIN = this.m__calculate(this.ads_config.bid_price.targeting.min / 100000)
      this.DAILY_BUDGET_MIN = this.m__calculate(this.ads_config.ads_config.product_ads.manual.search_product.min_daily_budget / 100000)
    }
  },

  watch: {
    'config_campaign_price_type': function () {
      if (this.config_campaign_price_type === 'auto') {
        this.config_campaign_creative = 'default'
      }
    }
  },

  computed: {
    c__product_filter_list() {
      let result = this.product_list

      result = result.filter(i => !this.product_selected_list.some(ii => ii.id === i.id))

      if (this.product_sort_option.order) {
        this.product_sort_option.order === 'ascending' && (result = _orderBy(result, [this.product_sort_option.prop], ['asc']))
        this.product_sort_option.order === 'descending' && (result = _orderBy(result, [this.product_sort_option.prop], ['desc']))
      }

      const keyword = this.remove_unicode(this.product_filter.keyword)
      return result.filter(i => i.id.toString().includes(keyword) || this.remove_unicode(i.name.normalize()).includes(this.remove_unicode(keyword)))
    },

    c__product_display_list() {
      const limit = this.product_filter.page_size
      const skip = limit * (this.product_filter.current_page - 1)

      return _take(_drop(this.c__product_filter_list, skip), limit)
    },

    // todo: old create search campaign computed
    c__excel_keyword_display_list() {
      const limit = this.excel_keyword_filter.page_size
      const skip = limit * (this.excel_keyword_filter.current_page - 1)

      return _take(_drop(this.excel_keyword, skip), limit)
    },

    c__mipee_keywords_display_list() {
      let result = this.mipee_suggest_keywords

      if (this.mipee_filter.sort_option.order) {
        this.mipee_filter.sort_option.order === 'ascending' && (result = _orderBy(result, [this.mipee_filter.sort_option.prop], ['asc']))
        this.mipee_filter.sort_option.order === 'descending' && (result = _orderBy(result, [this.mipee_filter.sort_option.prop], ['desc']))
      }

      const limit = this.mipee_filter.page_size
      const skip = limit * (this.mipee_filter.current_page - 1)

      return _take(_drop(result, skip), limit)
    },

    c__shopee_keyword_display_list() {
      let result = this.shopee_suggest_keywords

      if (this.shopee_filter.sort_option.order) {
        this.shopee_filter.sort_option.order === 'ascending' && (result = _orderBy(result, [this.shopee_filter.sort_option.prop], ['asc']))
        this.shopee_filter.sort_option.order === 'descending' && (result = _orderBy(result, [this.shopee_filter.sort_option.prop], ['desc']))
      }

      const limit = this.shopee_filter.page_size
      const skip = limit * (this.shopee_filter.current_page - 1)

      return _take(_drop(result, skip), limit)
    },

    c__search_keyword_display_list() {
      let result = this.search_keyword

      if (this.search_keyword_filter.sort_option.order) {
        this.search_keyword_filter.sort_option.order === 'ascending' && (result = _orderBy(result, [this.search_keyword_filter.sort_option.prop], ['asc']))
        this.search_keyword_filter.sort_option.order === 'descending' && (result = _orderBy(result, [this.search_keyword_filter.sort_option.prop], ['desc']))
      }

      const limit = this.search_keyword_filter.page_size
      const skip = limit * (this.search_keyword_filter.current_page - 1)

      return _take(_drop(result, skip), limit)
    },

    c__added_keyword_display_list() {
      const limit = this.added_keyword_filter.page_size
      const skip = limit * (this.added_keyword_filter.current_page - 1)

      return _take(_drop(this.added_keyword, skip), limit)
    },

    c__fff_result_display_list() {
      const limit = this.atosa_keyword_filter.page_size
      const skip = limit * (this.atosa_keyword_filter.current_page - 1)

      let result = this.fff_result

      if (this.fff_sort_option.order) {
        this.fff_sort_option.order === 'ascending' && (result = _orderBy(result, [this.fff_sort_option.prop], ['asc']))
        this.fff_sort_option.order === 'descending' && (result = _orderBy(result, [this.fff_sort_option.prop], ['desc']))
      }

      return _take(_drop(result, skip), limit)
    },

    c__auto_is_eligible() {
      return this.bidding_strategy_eligibility.auto && this.bidding_strategy_eligibility.auto.is_eligible
    },

    c__auto_is_not_eligible() {
      return this.bidding_strategy_eligibility.auto && !this.bidding_strategy_eligibility.auto.is_eligible
    },

    c__auto_ongoing_campaign_id() {
      return this.bidding_strategy_eligibility.auto && this.bidding_strategy_eligibility.auto.ongoing_campaign_id
        ? this.bidding_strategy_eligibility.auto.ongoing_campaign_id
        : null
    },
  },

  methods: {
    m__show_upload_shop_ads_image() {
      this.$el.querySelector(`#input_shop_ads_image`).click()
    },

    async m__upload_shop_ads_image(e) {
      try {
        const file_store = e.target.files || e.dataTransfer.files
        if (file_store.length === 0) {
          return
        }

        const response = await this.sp_user.upload_image(file_store[0])
        if (response && response.data && response.data.data && response.data.data.resource_id) {
          this.campaign_info.image_url = response.data.data.resource_id
        }
      } catch (e) {
        console.error(e)
      } finally {
        e.target.value = null
      }
    },

    async m__get_preview_data() {
      const info_response = await this.sp_user.get_shop_info()
      this.campaign_info.image_url = info_response.data.portrait

      const preview_response = await this.sp_user.marketing_pas_get_preview_data()
      this.shop_preview_data = preview_response.data
    },

    async m__get_bidding_strategy_eligibility() {
      const response = await this.sp_user.marketing_pas_get_bidding_strategy_eligibility()
      this.bidding_strategy_eligibility = response.data

      if (!this.bidding_strategy_eligibility) return

      if (this.c__auto_is_not_eligible) {
        this.config_campaign_price_type = 'manual'
      }
    },

    async m__confirm_create_new_product_campaign() {
      this.create_campaigns_result = []

      if (!this.campaign_info.name) {
        this.ntf_w(this.$t('required.ad_name'))
        return
      }

      if (this.campaign_info.campaign_time === 'daterange') {
        if (!this.campaign_info.campaign_date_range[0] || !this.campaign_info.campaign_date_range[1]) {
          this.ntf_w(this.$t('required.ad_duration'))
          return
        }
        if (this.dayjs(this.campaign_info.campaign_date_range[0]).isAfter(this.campaign_info.campaign_date_range[1])) {
          this.ntf_w(this.ntf_w(this.$t('base.y_gt_than_x', {
            y: this.$t('base.start_time'),
            x: this.$t('base.end_time'),
          })))
          return
        }
      }

      if (this.config_campaign_price_type === 'manual' && !this.added_keyword.length) {
        this.ntf_w(this.$t('required.must_select_at_least_keyword'))
        return
      }

      try {
        await this.$confirm(this.$t('ads.update_budget_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      this.loading.create_campaign = true

      // const check_duplicate_name_response = await this.sp_user.marketing_pas_check_duplicate_name({name: this.campaign_info.name})
      // if (check_duplicate_name_response && check_duplicate_name_response.data && check_duplicate_name_response.data.is_duplicate) {
      //   this.ntf_w(this.$t('ads.campaign_name_already_exists'))
      //   this.loading.create_campaign = false
      //   return
      // }

      try {
        const form = {
          reference_id: make_uuid(),
          campaign: {
            campaign_id: 0,
            target_broad_roi: 0,
            daily_budget: this.campaign_info.budget_type === 'unlimited' ? 0 : +this.campaign_info.daily_budget * 100000,
            creative: {
              is_use_default: true,
              landing_page: 'shop_homepage',
              image_url: this.campaign_info.image_url,
              tagline: this.campaign_info.tagline
            },
            bidding_strategy: this.config_campaign_price_type,
            start_time: this.campaign_info.campaign_time === 'unlimited'
              ? this.dayjs().startOf('day').unix()
              : this.dayjs(this.campaign_info.campaign_date_range[0]).startOf('day').unix(),
            end_time: this.campaign_info.campaign_time === 'unlimited'
              ? 0
              : this.dayjs(this.campaign_info.campaign_date_range[1]).endOf('day').unix(),
            name: this.campaign_info.name
          },
          header: {}
        }

        if (this.config_campaign_creative === 'auto') {
          form.creative = {
            is_use_default: true
          }
        }

        if (this.config_campaign_price_type === 'auto') {
          form.target_broad_roi = 0
          form.creative = {
            is_use_default: true
          }
          if (this.c__auto_is_eligible && this.c__auto_ongoing_campaign_id) {
            form.campaign.campaign_id = this.c__auto_ongoing_campaign_id
          }
        }

        if (this.config_campaign_price_type === 'manual') {
          form.campaign.bidding_strategy = 'manual'
          form.campaign.keyword_list = this.added_keyword.map(keyword => {
            keyword.match_type = this.form_add_new_campaign.match_type
            keyword.price = this.m__calculate(keyword.recommend_price)
            this.m__prefix_keyword_price(keyword)

            return {
              keyword: keyword.keyword.replace(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]/g, '').trim().toLowerCase().normalize(),
              bid_price: keyword.price * 100000,
              match_type: keyword.match_type === 0 ? 'exact' : 'broad'
            }
          })

          const MAX_LENGTH = ADS_CONSTANTS.MAX_KEYWORDS_LENGTH
          form.campaign.keyword_list = _uniqBy(form.campaign.keyword_list, 'keyword').slice(0, MAX_LENGTH)
        }

        console.log(form)
        const create_response = await this.sp_user.marketing_pas_publish_campaign(form, 'shop')
        console.log(create_response)

        if (create_response.code === 0) {
          this.ntf_s(this.$t('base.create_campaign_success'))
        } else {
          this.ntf_w(this.$t('ads.error_with_creating_campaign') + '. ' + this.$t('base.error_code') + ': ' + (create_response.msg || create_response.message) + ', code:' + create_response.code)
        }

        // this.show_dialog.shopee_result = true
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.create_campaign = false
      }
    },

    m__back_to_list() {
      this.$emit('back_to_list')
    },

    m__product_sort_change({
                             prop,
                             order
                           }) {
      this.product_sort_option.order = order
      this.product_sort_option.prop = prop
    },

    m__show_select_product_dialog() {
      this.show_dialog.select_product = true
    },

    m__confirm_select_product() {
      this.product_selected_list.push(...this.c__product_filter_list.filter(i => i.checked))
      this.show_dialog.select_product = false

      this.m__get_shopee_suggest_keywords().catch(console.error)
    },

    // todo: old create search campaign
    async m__get_keyword_file() {
      const response = await this.$http.get(this.API.marketing.keyword_file.list, this.cf())
      this.keyword_file_list = response.body.data
    },

    async m__import_excel_file(event) {
      try {
        const file_store = event.target.files || event.dataTransfer.files
        if (file_store.length === 0) {
          return
        }

        const raw = await readXlsxFile(file_store[0])
        for (const row of raw) {
          if (row && row[0] && typeof row[0] === 'string' && !this.excel_keyword.some(i => i.keyword === row[0].toLowerCase())) {
            this.excel_keyword.push({
              keyword: row[0].toLowerCase(),
              recommend_price: row[1] && !Number.isNaN(+row[1]) ? +row[1] : null,
              search_volume: 0,
              algorithm: 'kwrcmdv2',
              input_price: row[1] && !Number.isNaN(+row[1]) ? +row[1] : null
            })
          }
        }

        if (this.excel_keyword.length) {
          try {
            const resp = await this.$http.post(this.API.URL_API_SRV_2 + '/keyword/save_and_result', {
              mipeeUserId: this.$store.state.userInfo.username,
              keyword: this.excel_keyword[0].keyword,
              data: this.excel_keyword.map(i => i.keyword),
              country: this.sp_user.country
            }, this.cf())
            this.save_and_result_list = resp.body
          } catch (e) {
            console.error(e)
          }

          for (const keyword of this.excel_keyword) {
            if (keyword.recommend_price) continue

            const found = this.save_and_result_list.find(i => i.keyword === keyword.keyword)
            if (found) {
              keyword.search_volume = found.volume
              if (keyword.recommend_price === 0) keyword.recommend_price = this.m__calculate(found.recommendPrice)
            } else {
              const info = await this.sp_user.marketing_get_keyword_volume(keyword.keyword, this.product_list[0].id)
              keyword.search_volume = this.m__calculate(info.search_volume)
              keyword.algorithm = info.algorithm
              if (keyword.recommend_price === 0) keyword.recommend_price = this.m__calculate(info.recommend_price)
            }
          }
        }
      } catch (e) {
        console.log(e)
        this.ntf_w(this.$t('base.error_reading_file'))
      } finally {
        event.target.value = null
      }
    },

    m__show_import_excel_file() {
      this.$el.querySelector(`#input_control_create`).click()
    },

    m__is_allow_keyword_tool() {
      const extent_package = this.$store.state.package.extend_package ? this.$store.state.package.extend_package.find(i => i.channel === 'shopee_marketing') : null
      if (extent_package) {
        return !!(this.dayjs().isBefore(this.dayjs(new Date(extent_package.license_to)), 's') &&
          extent_package.package.extra_data && extent_package.package.extra_data.marketing &&
          extent_package.package.extra_data.marketing.keyword_tool)
      } else {
        return false
      }
    },

    m__is_allow_delete_keyword() {
      const pack = this.$store.state.package && this.$store.state.package.extend_package && this.$store.state.package.extend_package.find(i => i.channel === 'shopee_marketing')
      return pack && pack.package && pack.package.extra_data && pack.package.extra_data.marketing && pack.package.extra_data.marketing.delete_keyword
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },

    m__add_all() {
      let source = []

      if (this.radio === '1') {
        source = this.shopee_suggest_keywords
      }
      if (this.radio === '2') {
        const data = JSON.parse(JSON.stringify(this.mipee_suggest_keywords))
        source = data.map(i => {
          i.recommend_price = this.form_add_new_campaign.price_type === 'mipee' ? i.price : i.recommend_price
          return i
        })
      }
      if (this.radio === '3') {
        source = this.search_keyword
      }
      if (this.radio === '4') {
        source = this.fff_result.slice(0, 100)
      }
      if (this.radio === '5') {
        source = this.excel_keyword
      }

      if (source) {
        for (let i = 0; i < source.length; i++) {
          if (this.omit_duplicated_keyword) {
            if (!this.added_keyword.find(e => e.keyword.normalize() === source[i].keyword.normalize())) {
              this.added_keyword.push({
                ...source[i],
                recommend_price: source[i].input_price || source[i].recommend_price || this.MATCH_TYPE_0_MIN
              })
            }
          } else {
            if (!this.added_keyword.find(e => e.keyword === source[i].keyword)) {
              this.added_keyword.push({
                ...source[i],
                recommend_price: source[i].input_price || source[i].recommend_price || this.MATCH_TYPE_0_MIN
              })
            }
          }
        }
      }
    },

    m__can_add(item) {
      return !this.added_keyword.find(i => i.keyword === item.keyword)
    },

    m__add_keyword(item, source) {
      if (source === 'shopee_suggest_keywords') {
        this.added_keyword.push({
          keyword: item.keyword,
          recommend_price: item.input_price || item.recommend_price || this.MATCH_TYPE_0_MIN,
          sp_volume: item.search_volume || item.sp_volume || 0
        })
      } else if (source === 'mipee_suggest_keywords') {
        this.added_keyword.push({
          keyword: item.keyword,
          recommend_price: item.input_price || item.recommend_price || this.MATCH_TYPE_0_MIN,
          sp_volume: item.search_volume || item.sp_volume || 0
        })
      } else if (source === 'search_shopee_keywords') {
        this.added_keyword.push({
          keyword: item.keyword,
          recommend_price: item.input_price || item.recommend_price || this.MATCH_TYPE_0_MIN,
          sp_volume: item.search_volume || item.sp_volume || 0
        })
      } else {
        this.added_keyword.push({
          ...item,
          recommend_price: item.input_price || item.recommend_price || this.MATCH_TYPE_0_MIN
        })
      }
    },

    m__remove_keyword(keyword) {
      this.added_keyword = this.added_keyword.filter(i => i.keyword !== keyword.keyword)
    },

    m__remove_product(index) {
      if (!this.product_selected_list.length || this.product_selected_list.length === 1) {
        return
      }

      this.product_selected_list.splice(index, 1)
    },

    async m__suggest_keyword(queryString, cb) {
      if (!queryString) {
        cb([])
        return
      }
      let hint_keywords = await this.sp_user.marketing_get_hint_keyword(queryString)
      cb(hint_keywords.map(e => ({value: e.keyword})))
    },

    async m__search_sp_keyword(keyword) {
      this.search_keyword = []

      if (!keyword.value) {
        return
      }

      let suggest_keywords_resp = await this.sp_user.shop_ads_search_keywords(keyword.value)
      while (!suggest_keywords_resp || !suggest_keywords_resp.data) {
        await this.sleep(2000)
        suggest_keywords_resp = await this.sp_user.shop_ads_search_keywords(keyword.value)
      }

      for (const item of suggest_keywords_resp.data) {
        this.search_keyword.push({
          ...item,
          checked: false,
          sp_volume: item.search_volume,
          sp_price: this.m__calculate(item.recommend_price)
        })
      }
    },

    async m__get_sp_keyword_info(keyword) {
      try {
        let info = await this.sp_user.marketing_get_keyword_volume(keyword.keyword, this.product_list[0].id)
        if (info !== null) {
          keyword.sp_volume = info.search_volume
          keyword.sp_price = keyword.recommend_price = this.m__calculate(info.recommend_price)
        }
      } catch (e) {
      }
    },

    m__prefix_keyword_price(keyword) {
      if (!keyword.price) keyword.price = this.MATCH_TYPE_0_MIN

      if (keyword.match_type === 0 && keyword.price < this.MATCH_TYPE_0_MIN) {
        keyword.price = this.MATCH_TYPE_0_MIN
      }
      if (keyword.match_type === 1 && keyword.price < this.MATCH_TYPE_1_MIN) {
        keyword.price = this.MATCH_TYPE_1_MIN
      }
    },

    async m__get_keyword_file_detail() {
      const response = await this.$http.get(this.API.marketing.keyword_file.detail.replace('_id', this.selected_keyword_file), this.cf())
      for (const i of response.body.data.keyword_json) {
        i.search_volume = 0
        i.recommend_price = 0
      }
      this.mipee_suggest_keywords = response.body.data.keyword_json.map(i => {
        i.checked = true
        return i
      })

      for (const i of this.mipee_suggest_keywords) {
        await this.m__get_keyword_sp_info(i)
        await this.sleep(200)
      }
    },

    async m__get_keyword_sp_info(keyword) {
      try {
        let info = await this.sp_user.marketing_get_keyword_volume(keyword.keyword, null, 3)
        keyword.search_volume = info.search_volume
        keyword.recommend_price = this.m__calculate(info.recommend_price)
      } catch (error) {
        console.log(error)
      }
    },

    async m__get_shopee_suggest_keywords() {
      const response = await this.sp_user.shop_ads_get_suggest_keyword_price(null)
      if (response && response.data) {
        response.data.forEach(i => {
          i.recommend_price = this.m__calculate(i.recommend_price)
        })
        this.shopee_suggest_keywords.push(...response.data)
      }
      this.shopee_suggest_keywords = _uniqBy(this.shopee_suggest_keywords, 'keyword')
      this.loading.shopee_suggest_keywords = false
    },

    m__remove_shopee_keyword(keyword) {
      const index = this.shopee_suggest_keywords.findIndex(i => keyword === keyword)
      this.shopee_suggest_keywords.splice(index, 1)
    },

    async m__get_categories() {
      const response = await this.sp_user.get_categories()

      for (let i = 0; i < response.data.list.length; i++) {
        if (this.product_list.find(item => item.category_path && item.category_path[0] === response.data.list[i].id)) {
          this.category_list.push(response.data.list[i])
        }
      }

      if (this.category_list.length) {
        this.selected_category = this.category_list[0].id
      }
    },

    async m__get_shop_categories() {
      const response = await this.sp_user.get_shop_categories()
      if (response.data && response.data.list) {
        this.shop_category_list = response.data.list
      }
      if (this.shop_category_list.length) {
        this.selected_shop_category = this.shop_category_list[0].id
      }
    },

    m__show_update_keyword_dialog() {
      this.show_dialog.update_keyword_price = true
    },

    m__update_keyword_price() {
      if (this.form_update_multiple_keyword_price.update_type === 1 && this.form_update_multiple_keyword_price.update_by_cost_value) {
        this.added_keyword.forEach(i => {
          if (this.form_update_multiple_keyword_price.update_by_cost === 'increase') {
            i.recommend_price += this.m__calculate(this.form_update_multiple_keyword_price.update_by_cost_value)
          }

          if (this.form_update_multiple_keyword_price.update_by_cost === 'reduce') {
            i.recommend_price -= this.m__calculate(this.form_update_multiple_keyword_price.update_by_cost_value)
          }
        })
      }

      if (this.form_update_multiple_keyword_price.update_type === 2 && this.form_update_multiple_keyword_price.update_by_percent_value) {
        this.added_keyword.forEach(i => {
          if (this.form_update_multiple_keyword_price.update_by_percent === 'increase') {
            i.recommend_price += (i.recommend_price * this.m__calculate(this.form_update_multiple_keyword_price.update_by_percent_value) / 100)
          }

          if (this.form_update_multiple_keyword_price.update_by_percent === 'reduce') {
            i.recommend_price -= (i.recommend_price * this.m__calculate(this.form_update_multiple_keyword_price.update_by_percent_value) / 100)
          }
        })
      }

      if (this.form_update_multiple_keyword_price.update_type === 3) {
        this.added_keyword.forEach(i => {
          i.recommend_price = this.m__calculate(this.form_update_multiple_keyword_price.price)
        })
      }

      this.show_dialog.update_keyword_price = false
    },

    async m__enter_input() {
      if (!this.fff_loading) {
        await this.m__try_get_keyword_result()
      }
    },

    async m__try_get_keyword_result() {
      this.fff_loading = true
      let keyword_list = await this.m__get_suggestion_keyword(this.base_keyword)
      let result = await this.fff.get_keyword_result(keyword_list, 5000, this.base_keyword)
      if (result === null) {
        await this.$nextTick(() => {
          this.ntf_w(this.$t('keyword.error_while_get_data'))
        })
      } else if (!result.data || !result.data.keywords || !result.data.keywords.length || result.data.keywords.length < 30) {
        this.ntf_w(`${this.$t('base.keywords_result_not_found')} "${this.base_keyword}"`)
      } else {
        let temp = result.data.keywords.map(e => {
          return {
            ...e,
            results: Math.round(e.results) || 0,
            checked: false,
            sp_volume: 0,
            loading: false,
            sp_price: 0
          }
        })
        if (!temp.some(i => i.keyword === this.base_keyword)) {
          const base_item = {
            keyword: this.base_keyword,
            results: 0,
            sp_volume: 0,
            sp_price: 0,
            relevance: 0,
            checked: false,
            loading: false
          }
          temp.unshift(base_item)
        }

        if (temp[0].keyword !== this.base_keyword) {
          const index = temp.findIndex(i => i.keyword === this.base_keyword)
          const temp_item = temp[index]
          temp.splice(index, 1)
          temp.unshift(temp_item)
        }

        const first = temp.shift()
        this.fff_result = _take(_orderBy(temp, ['results'], ['desc']), 500)
        this.fff_result.unshift(first)

        const keyword = this.base_keyword
        const extend_resp = await this.sp_user.shop_ads_search_keywords(keyword)
        if (extend_resp && extend_resp.data) {
          let index_splice = 1
          for (const item of extend_resp.data) {
            if (this.contain_at_least(keyword, item.keyword)) {
              const keyword = {
                keyword: item.keyword,
                results: 0,
                sp_volume: item.search_volume,
                sp_price: item.recommend_price,
                relevance: item.relevance,
                checked: false,
                loading: false
              }
              this.fff_result.splice(index_splice++, 0, keyword)
            }
          }
        }

        try {
          const resp = await this.$http.post(this.API.URL_API_SRV_2 + '/keyword/save_and_result', {
            mipeeUserId: this.$store.state.userInfo.username,
            keyword: this.base_keyword,
            data: this.fff_result.map(i => i.keyword),
            country: this.sp_user.country
          }, this.cf())
          this.save_and_result_list = resp.body
        } catch (e) {
          console.error(e)
        }

        for (const item of this.fff_result) {
          item.keyword = item.keyword.normalize()
        }
        this.result = _uniqBy(this.fff_result, 'keyword')

        this.fetch_index = 0
        this.fetch_keyword = this.base_keyword
        await this.m__start_get_sp_keyword()
      }

      this.fff_loading = false
    },

    async m__start_get_sp_keyword() {
      this.fetch_loading = true

      for (const item of this.fff_result) {
        if (this.fetch_keyword !== this.base_keyword) {
          break
        }

        if (item.sp_volume && item.sp_price) continue

        const found = this.save_and_result_list.find(i => i.keyword === item.keyword)
        if (found) {
          item.relevance = found.relevance
          item.sp_volume = found.volume
          item.sp_price = item.recommend_price = this.m__calculate(found.recommendPrice)
        } else {
          await this.m__get_sp_keyword_info(item)
        }
      }

      this.fff_clone = JSON.parse(JSON.stringify(this.fff_result))
      this.fetch_loading = false
    },

    async m__get_suggestion_keyword(keyword) {
      const product_id = this.product_list[0] ? this.product_list[0].id : null
      const hint_keywords = await this.sp_user.marketing_list_keyword_hint(keyword, product_id, 0)
      return hint_keywords.data.map(i => i.keyword)
    },

    m__initial_save_keyword_file() {
      if (!this.m__is_allow_keyword_tool()) {
        this.ntf_w(this.$t('package.not_for_trial'))
        return
      }

      if (this.added_keyword.length > 0) {
        this.save_keyword_file.filename = `${this.$t('keyword.file')} ${this.added_keyword[0].keyword} (${this.added_keyword.length} ${this.$t('base.keyword')} - ${this.$t('base.at')} ${this.timeFormat(new Date())})`
        this.save_keyword_file.show = true
      } else {
        this.ntf_w(this.$t('keyword.empty_to_save'))
      }
    },

    m__try_save_keyword_file() {
      this.confirm(this.$t('keyword.confirm_save_file_x_name', {x: this.save_keyword_file.filename}), () => {
        this.save_keyword_file.loading = true

        this.$http.post(this.API.marketing.keyword_file.add, {
          filename: this.save_keyword_file.filename,
          keyword_json: this.added_keyword.map(i => {
            return {
              checked: true,
              keyword: i.keyword,
              keyword_source_type: 0,
              price: i.recommend_price,
              record_type: 0,
              rnum: 0,
              sp_price: i.recommend_price,
              sp_volume: i.sp_volume
            }
          })
        }, this.cf())
          .then(async (resp) => {
            this.ntf_s(resp)
            this.save_keyword_file.loading = false
            this.save_keyword_file.show = false

            this.$emit('m__reload_saved_keyword')
          })
          .catch(error => {
            console.log(error)
            this.ntf_w(error)
            this.save_keyword_file.loading = false
          })
      })
    },

    m__fff_sort_change({
                         prop,
                         order
                       }) {
      this.fff_sort_option.order = order
      this.fff_sort_option.prop = prop
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/pas/component/create_shop.vue